<template>
  <div class="goodsList" style="background: #fff;">
    <div v-if="showPage">
      <div :class="['main', {'no-foot': showBlock != 'orderDishes'}]">
        <div class="top-area" id="topArea" @click="toggleProp('shopInfo')" style="margin-bottom: 0.5rem">
          <div class="bg-pic-box">
            <div class="bg-pic" :style="{backgroundImage:'url('+shopDetail.pic+')'}">
              <div class="top-area-mask"></div>
            </div>
          </div>
          <div class="shop-img" :style="{backgroundImage: 'url('+shopDetail.pic+')'}"></div>
          <div class="shop-info fl">
            <div class="shop-des">
              <div class="flexrow ellipse" style="width: 100%">
                <span>起送 ￥{{ shopDetail.threshold_amount }}</span><span
                style="margin: 0 0.05rem;color: #E3E3E3">|</span>
                <span v-if="shopDetail.delivery_fee_text">{{ shopDetail.delivery_fee_text }}</span>
                <template v-else>
                  <span>配送￥</span>
                  <span v-if="shopDetail.new_delivery_fee || shopDetail.new_delivery_fee === 0">
                    {{ shopDetail.new_delivery_fee }}
                  </span>
                  <span v-else>{{ shopDetail.delivery_fee }}</span>
                  <span v-if="shopDetail.is_many_delivery == 1">起</span>
                </template>
                <del v-if="shopDetail.new_delivery_fee || shopDetail.new_delivery_fee === 0">￥{{ shopDetail.delivery_fee }}</del>
<!--                <div v-if="shopDetail.new_delivery_fee || shopDetail.new_delivery_fee === 0">-->
<!--                  配送￥{{ shopDetail.new_delivery_fee }}-->
<!--                  <span v-if="shopDetail.is_many_delivery == 1">起</span>-->
<!--                  <del>￥{{ shopDetail.delivery_fee }}</del>-->
<!--                </div>-->
<!--                <div v-else>-->
<!--                  配送￥{{ shopDetail.delivery_fee }}-->
<!--                  <span v-if="shopDetail.is_many_delivery == 1">起</span>-->
<!--                </div>-->
                <span v-if="shopDetail.delivery_type == 1">(商家配送)</span>
                <span style="margin: 0 0.05rem;color: #E3E3E3">|</span>月售{{ shopDetail.sales_append }}单
                <!--                <span class="grate-shop" v-if="shopDetail.is_recommend==1">优秀店铺</span>-->
              </div>
              <div class="announcement" v-if="shopDetail.announcement && !shopDetail.dinner_duration">
                公告：{{ shopDetail.announcement }}
              </div>
              <div v-if="shopDetail.dinner_duration" style="font-size: .22rem; width: 100%">
                {{ shopDetail.dinner_duration }}
              </div>
            </div>
          </div>
        </div>
        <!--店铺优惠券-->
        <div class="shop-coupon" v-if="(couponInfo.coupon_list && couponInfo.coupon_list.length > 0) || shopDetail.promotion_package">
          <!-- 券包 -->
          <div style="height: 100%" v-if="shopDetail.promotion_package && shopDetail.promotion_package.length > 0">
            <div v-for="(coupon,index) in shopDetail.promotion_package" :key="index" class="coupon-item package"
               :class="{checked: coupon.status==1}">
              <div class="info" @click="buyCouponPackage(coupon)">
                <div class="fs-20">¥<span
                  class="fs-40 fw-bold">{{ coupon.package_price }}</span>
                </div>
                <div style="padding: 0 .15rem">
                  <div class="fs-24 ellipse">{{ coupon.promotion_name }}</div>
                  <div class="fs-18 ellipse">{{ coupon.package_desc }}</div>
                </div>
                <img class="c-line" v-if="coupon.status==1" src="../assets/images/img_line_coupon_red.png"/>
                <img class="c-line" v-else src="../assets/images/img_line_coupon_white.png"/>
                <div class="fs-18 ac" style="width:.8rem" v-if="coupon.status==1">已购</div>
                <div class="fs-18 ac" style="width:.8rem" v-else>超值购</div>
              </div>
            </div>
          </div>
          <div v-for="(coupon,index) in couponInfo.coupon_list" :key="index" class="coupon-item"
               :class="{checked: coupon.status==1 || coupon.status==2}">
            <div class="info" @click="receiveCoupon(coupon)">
              <div class="fs-20">¥<span
                class="fs-40 fw-bold">{{ coupon.couponAmount }}</span>{{ coupon.decimal ? '.' + coupon.decimal : '' }}
              </div>
              <div style="padding: 0 .15rem">
                <div class="fs-24">{{ coupon.couponName }}</div>
                <div class="fs-18 ellipse">{{ coupon.amountCondition }}</div>
              </div>
              <img class="c-line" v-if="coupon.status==1 || coupon.status==2" src="../assets/images/img_line_coupon_red.png"/>
              <img class="c-line" v-else src="../assets/images/img_line_coupon_white.png"/>
              <div class="fs-18 ac" style="width:.8rem" v-if="coupon.status==1">已领</div>
              <div class="fs-18 ac" style="width:.8rem" v-else-if="coupon.status==2">不可领</div>
              <div class="fs-18 ac" style="width:.8rem" v-else>领</div>
            </div>
          </div>
        </div>
        <div>
          <div class="activity-info"
               v-if="(shopDetail.promotion_list && shopDetail.promotion_list.length>0) || shopDetail.promotion_reduce">
            <div class="special-goods arrow-down flexrow" @click="toggleProp('shopInfo')">
              <div style="width:75%;">
                <div class="promotion_reduce" v-if="shopDetail.promotion_list1">
                  <span v-for="item in shopDetail.promotion_list1"
                        class="promotion_reduce-type border">{{ item }}</span>
                  <!--<span class="promotion_reduce-type border">满20减7</span>-->
                  <!--<span class="promotion_reduce-type border">满30减12</span>-->
                  <!--<span class="promotion_reduce-type border">满20减7</span>-->
                  <!--<span class="promotion_reduce-type border">满30减12</span>-->
                </div>
                <!--<span-->
                <!--v-if="shopDetail.promotion_list && shopDetail.promotion_list.length > 0"-->
                <!--:style="{backgroundImage:'url('+shopDetail.promotion_list[0].icon_url+')'}">-->
                <!--{{shopDetail.promotion_list[0].promotion_name}}-->
                <!--</span>-->
              </div>
              <span class="activities fr"
                    v-if="shopDetail.promotion_reduce && shopDetail.promotion_reduce.reduce_info.length>0">共{{
                  shopDetail.promotion_list ? (shopDetail.promotion_list.length + 1) : 1
                }}个活动</span>
              <span class="activities fr" v-else>共{{ shopDetail.promotion_list.length }}个活动</span>
            </div>
          </div>
        </div>
        <div class="announcement" style="margin-left: .26rem;color: #999"
             v-if="shopDetail.announcement && shopDetail.dinner_duration">公告：{{ shopDetail.announcement }}
        </div>
        <div class="navbar col33" id="checkTab" style="margin-top: 0.3rem">
          <a :class="{active: showBlock == 'orderDishes'}" @click="switchInfo($event)" id="orderDishes">商品</a>
          <a :class="{active: showBlock == 'commentInfo'}" @click="switchInfo($event)" id="commentInfo">评价</a>
          <a :class="{active: showBlock == 'shopInfo'}" @click="switchInfo($event)" id="shopInfo">商家</a>
          <!-- 店铺内搜索 -->
          <div class="shop-search" @click="toShopSearch()">
            <div class="box">
              <img src="../assets/images/home_icon_search_bg.png"/>
              <div style="color: #9b9b9b;">搜索商品</div>
            </div>
          </div>
        </div>

        <div class="content" v-show="showBlock == 'orderDishes'">
          <div v-if="req_type">
            <div class="goods-list1" id="goodList" >
              <div id="scroller" @touchmove.prevent style="padding-bottom: 100px">
                <ul id="myUl" style="border: none" v-for="item1 in myGoodsList" v-if="item1.goods_list && item1.goods_list.length">
                  <li v-for="(item,index) in item1.goods_list" style="border: none" :id="item.tag_id+'goods'+index">
                    <div class="goods-box" :class="item.gd_code == gdCode? 'isHightGood' : ''" @click="toggleProp('goodInfo',item)">
                      <div class="goods-img">
                        <div class="lazy goodimg" :style="{backgroundImage: 'url('+item.image_url+')'}"></div>
                      </div>
                      <div class="goods-des flexrow" style="padding-right: 0">
                        <div class="name">{{ item.goods_name }}</div>
                        <p v-if="item.activity_specification && item.is_single_spec == 0">
                          {{ item.activity_specification }}</p>
                        <p>销量 {{ item.sales_volume }}</p>
                        <div class="flexrow" style="justify-content: space-between;align-items: center">
                          <p v-if="item.activity_id>0">
                            <span class="price amounts" style="font-weight: bold;">￥{{ item.activity_price }}</span>
                            <del>￥{{ item.price }}</del>
                          </p>
                          <p v-else>
                            <span class="price amounts" style="font-weight: bold;">￥{{ item.price }}</span>
                            <span v-if="item.is_single_spec==0">起</span>
                          </p>
                          <div v-if="shopDetail.is_open == 1">
                            <div class="num-box" v-if="item.sales_status == 1 && item.stock > 0">
                              <div v-if="item.is_options == 1" class="btn-yellow select-spec-btn"
                                   @click.stop="toggleProp('specInfo',item)">
                                <span>选规格</span>
                                <!--<span v-else>选属性</span>-->
                                <span class="num" v-if="item.cartNum>0">{{ item.cartNum }}</span>
                              </div>
                              <div v-else>
                              <span class="btns minusBtn icon-removecart" @click.stop="minusGoods(item)"
                                    v-if="item.cartNum>0"></span>
                                <span class="box" v-if="item.cartNum>0">{{ item.cartNum }}</span>
                                <span v-if="item.smallNumber > 1 && !item.cartNum" class="btn-yellow select-spec-btn"
                                      @click.stop="addGoods(item)">{{ item.smallNumber }}份起购</span>
                                <span v-else-if="!item.noStock || item.smallNumber <= 1 && !item.cartNum"
                                      class="btns addBtn icon-addtocart" @click.stop="addGoods(item)"></span>
                                <span v-else class="btns addBtn icon-cantaddtocart"></span>
                              </div>

                            </div>
                            <span class="num-box sales-out" v-else>售罄</span>
                          </div>
                        </div>
                      </div>
                      <div class="sale-box" v-if="item.activity_desc">
                      <span class="no-bg"
                            v-if="item.activity_desc && item.activity_desc != ''">{{ item.activity_desc }}</span>
                        <span class="bg"
                              v-if="item.activity_id>0 && item.sales_status == 1 && item.left_stock<=10">剩{{item.left_stock}}份</span>
                      </div>
                      <div style="padding-left: 1.26rem;margin-top: 0.1rem">
                      <span class="activity-tip"
                            v-if='item.partner != 0 && item.activity_desc_extra'>{{item.activity_desc_extra}}</span>
                        <span class="activity-tip" v-if="item.show_text">{{ item.show_text }}</span>
                      </div>
                    </div>
                  </li>
                  <li class="no-more"  v-if="noMore">没有更多内容啦~请切换下一个分类</li>
                </ul>
              </div>

            </div>
            <div class="side-bar" id="sideBar1">
              <div class="side-bar-scroll" id="scrollBox1">
                <a v-for="item in myGoodsList" :id="item.tag_name" :class="{active: item.isActive}" @click="scrollGoods1(item)">
                  <span class="icon icon-sale" v-if="item.is_special_tag>0">{{ item.tag_name_short }}</span>
                  <span v-else>{{ item.tag_name_short }}</span>
                  <span class="num" v-if="item.tagNum>0 && item.is_special_tag<=0">{{ item.tagNum }}</span>
                </a>
              </div>
            </div>
          </div>

          <div v-else>
            <div class="goods-list" id="goodList">
              <div id="scroller" @touchmove.prevent style="padding-bottom: 100px">
                <ul v-for="item in goodsList" style="border: none">
                  <li class="title" :id="item.tag_id">{{ item.tag_name }}</li>
                  <li v-for="(item2,index) in item.goods_list" style="border: none" :id="item.tag_id+'goods'+index">
                    <div class="goods-box" :class="item2.gd_code == gdCode? 'isHightGood' : ''"  @click="toggleProp('goodInfo',item2)">
                      <div class="goods-img">
                        <div class="lazy goodimg" :style="{backgroundImage: 'url('+item2.image_url+')'}"></div>
                      </div>
                      <div class="goods-des flexrow" style="padding-right: 0">
                        <div class="name">{{ item2.goods_name }}</div>
                        <p v-if="item2.activity_specification && item2.is_single_spec == 0">
                          {{ item2.activity_specification }}</p>
                        <p>销量 {{ item2.sales_volume }}</p>
                        <div class="flexrow" style="justify-content: space-between;align-items: center">
                          <p v-if="item2.activity_id>0">
                            <span class="price amounts" style="font-weight: bold;">￥{{ item2.activity_price }}</span>
                            <del>￥{{ item2.price }}</del>
                          </p>
                          <p v-else>
                            <span class="price amounts" style="font-weight: bold;">￥{{ item2.price }}</span>
                            <span v-if="item2.is_single_spec==0">起</span>
                          </p>
                          <div v-if="shopDetail.is_open == 1">
                            <div class="num-box" v-if="item2.sales_status == 1 && item2.stock > 0">
                              <div v-if="item2.is_options == 1" class="btn-yellow select-spec-btn"
                                   @click.stop="toggleProp('specInfo',item2)">
                                <span>选规格</span>
                                <!--<span v-else>选属性</span>-->
                                <span class="num" v-if="item2.cartNum>0">{{ item2.cartNum }}</span>
                              </div>
                              <div v-else>
                              <span class="btns minusBtn icon-removecart" @click.stop="minusGoods(item2)"
                                    v-if="item2.cartNum>0"></span>
                                <span class="box" v-if="item2.cartNum>0">{{ item2.cartNum }}</span>
                                <span v-if="item2.smallNumber > 1 && !item2.cartNum" class="btn-yellow select-spec-btn"
                                      @click.stop="addGoods(item2)">{{ item2.smallNumber }}份起购</span>
                                <span v-else-if="!item2.noStock || item2.smallNumber <= 1 && !item2.cartNum"
                                      class="btns addBtn icon-addtocart" @click.stop="addGoods(item2)"></span>
                                <span v-else class="btns addBtn icon-cantaddtocart"></span>
                              </div>

                            </div>
                            <span class="num-box sales-out" v-else>售罄</span>
                          </div>
                        </div>


                      </div>
                      <div class="sale-box" v-if="item2.activity_desc">
                      <span class="no-bg"
                            v-if="item2.activity_desc && item2.activity_desc != ''">{{ item2.activity_desc }}</span>
                        <span class="bg"
                              v-if="item2.activity_id>0 && item2.sales_status == 1 && item2.left_stock<=10">剩{{
                          item2.left_stock
                        }}份</span>
                      </div>

                      <div style="padding-left: 1.26rem;margin-top: 0.1rem">
                      <span class="activity-tip"
                            v-if='item2.partner != 0 && item2.activity_desc_extra'>{{
                          item2.activity_desc_extra
                        }}</span>
                        <span class="activity-tip" v-if="item2.show_text">{{ item2.show_text }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="side-bar" id="sideBar">
              <div class="side-bar-scroll" id="scrollBox">
                <a v-for="item in goodsList" :id="item.tag_name" :class="{active: item.isActive}" @click="scrollGoods(item)">
                  <span class="icon icon-sale" v-if="item.is_special_tag>0">{{ item.tag_name_short }}</span>
                  <span v-else>{{ item.tag_name_short }}</span>
                  <span class="num" v-if="item.tagNum>0 && item.is_special_tag<=0">{{ item.tagNum }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div id="content3" class="content3 usercenter" v-show="showBlock == 'commentInfo'">
          <div>
            <div class="shop-comment">
              <span>{{ shopDetail.score }}</span>
              <CommentStars :qualityCode="shopDetail.score"></CommentStars>
              <div class="des" v-if="CommentNum != ''">{{ CommentNum }}名同学参与菜品反馈</div>
            </div>
            <!--<div>脑洞大开，神菜来袭，期待神评</div>-->
          </div>
          <ul class="comments-list" v-if="businessCommentList.length">
            <li v-for="item in businessCommentList">
              <div class="img" :style="{backgroundImage:'url('+item.userPhotoUrl+')'}"></div>
              <div class="info">
                <div class="name">{{ item.userName }}</div>
                <div class="flexrow" style="font-size:0.22rem; color:#797979;align-items: center"><span
                  style="margin-right: 0.1rem">评分</span>
                  <CommentStars :qualityCode="item.qualityCode"></CommentStars>
                </div>
                <div class="des" v-if="item.comment != ''">{{ item.comment }}</div>
                <PreviewPicture :previewPictures="item.urls"></PreviewPicture>
                <div class="goodsmark_list" v-if="item.goodsMarkList.length > 0">
                  <div v-if="item.goodList.length > 0"><span class="icon good"></span>
                    <p><span v-for="(item1,index) in item.goodList">{{ item1 }}<span
                      v-if="index < item.goodList.length-1">，</span></span></p></div>
                  <div v-if="item.badList.length > 0"><span class="icon bad"></span>
                    <p><span v-for="(item2, index) in item.badList">{{ item2 }}<span
                      v-if="index < item.badList.length-1">，</span></span></p></div>
                </div>
                <div v-if="item.isReply==1" class="reply_comment">商家回复：{{ item.replyComment }}</div>
                <div class="date">{{ item.date }}</div>
              </div>
            </li>
          </ul>
          <div v-else style="position: relative;height: 10rem;text-align: center">
            <div class="my-content">
              <img src="../../src/assets/images/icon_content.png" style="width: 2.37rem;height: 2.42rem" />
              <div>吃完记得给大厨一个反馈哦～</div>
            </div>
          </div>
        </div>
        <div id="content2" class="content2 usercenter" v-show="showBlock == 'shopInfo'">
          <div>
            <div class="shop-info">
              <h3>商家信息</h3>
              <div class="shop-info-box"><span class="tit">商家电话:</span><span
                class="con">{{ shopDetail.service_tel }}</span></div>
              <div class="shop-info-box"><span class="tit">商家地址:</span><span
                class="con">{{ shopDetail.address }}</span></div>
              <div class="shop-info-box" v-if="shopDetail.open_rules ==0 && shopDetail.open_setting != null"><span
                class="tit">营业时间:</span><span class="con">{{ openTime }}</span></div>
              <div class="shop-info-box"
                   v-if="shopDetail.open_rules ==1 && shopDetail.weeks_no && shopDetail.weeks_no.length>0">
                <span class="tit">营业时间:</span>
                <div class="con">
                  <div v-for="item in shopDetail.weeks_no">
                    <h4>{{ item.weekstr }}</h4>
                    <p v-for="item2 in item.open_setting">
                      {{ item2.begin_time }}-{{ item2.end_time }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="shopDetail.aptitude && shopDetail.aptitude.license_list && shopDetail.aptitude.license_list.length > 0">
                <span class="license">营业执照:</span>
                <!--                <img class="pic" :src="shopDetail.aptitude.license" @click="picPreview($event)">-->
                <PreviewPicture :previewPictures="shopDetail.aptitude.license_url_list"></PreviewPicture>
              </div>
              <div
                v-if="shopDetail.aptitude && shopDetail.aptitude.food_license_list && shopDetail.aptitude.food_license_list.length > 0">
                <span class="license">食品经营许可证(食品流通许可证):</span>
                <PreviewPicture :previewPictures="shopDetail.aptitude.food_license_url_list"></PreviewPicture>
                <!--                <img class="pic" :src="shopDetail.aptitude.food_license" @click="picPreview($event)">-->
              </div>
            </div>
          </div>
          <div class="list order-list">
            <ul>
              <li v-for="item in shopDetail.other_info">
                <a @click="showOtherInfo(item)">
                  <span class="fl">{{ item.name }}</span>
                  <span class="icon_arrow_next fr"></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--底部结算固定栏-->
      <div v-if="shopDetail.is_open == 1">
        <div v-if="showBlock == 'orderDishes'" style="width:100%;position: fixed;bottom: 1rem;left: 0;z-index: 18">
          <div v-if="cartInfo[shopCode].total>0">
            <!--购物车不为空-->
            <div class="promotion_reduce_tips" v-if="shopDetail.promotion_reduce && !hasSpecial">
              <div v-if="nextFullReductionAmountGap != ''">
                <span v-if="reductionAmount != ''">已减{{ reductionAmount }}元，</span>再买<span
                class="red">{{ nextFullReductionAmountGap }}元 </span>减<span
                class="red"> {{ nextFullReductionAmount }}元</span>
              </div>
              <div v-else-if="nextFullReductionAmountGap == ''">
                <span v-if="reductionAmount != ''">已减{{ reductionAmount }}元</span>
              </div>
            </div>
            <div class="promotion_reduce_tips" v-else-if="hasSpecial && reductionAmount > 0">
              <span>特价折扣优惠{{ reductionAmount }}元</span>
            </div>
          </div>
          <div v-else>
            <!--购物车为空-->
            <div class="promotion_reduce_tips"
                 v-if="shopDetail.promotion_reduce && shopDetail.promotion_reduce.reduce_info.length>0 && !hasSpecial">
              {{ shopDetail.promotion_reduce.promotion_name }}
            </div>
          </div>
        </div>
        <footer class="dark fixed cart flexrow" v-if="showBlock == 'orderDishes'"
                style="padding: 0 0.26rem;justify-content: space-between;align-items: center">
          <div class="footer-cart">
            <div class="cart-box-bg">
              <div class="cart-box empty" v-if="cartInfo[shopCode].total<=0"></div>
              <div class="cart-box" id="cart" v-else>
                <a @click="toggleProp('cart')">
                  <span class="num">{{ cartTotal }}</span>
                </a>
              </div>
            </div>
            <div class="price empty tips"
                 v-if="cartTotal<=0 && (shopDetail.is_self_take_new == 1 && shopDetail.is_take_out == 0 && shopDetail.is_eat_in == 0)">
              <span>只能打包自提</span></div>
            <div class="price empty tips"
                 v-if="cartTotal<=0 && (shopDetail.is_self_take_new == 0 && shopDetail.is_take_out == 0 && shopDetail.is_eat_in == 1)">
              <span>只能堂食</span></div>
            <div class="price empty tips"
                 v-if="cartTotal<=0 && (shopDetail.is_self_take_new == 1 && shopDetail.is_take_out == 0 && shopDetail.is_eat_in == 1)">
              <span>支持自提 | 堂食</span></div>
            <div class="price empty tips" v-else-if="cartTotal<=0 && shopDetail.is_take_out == 1">
              <span v-if="shopDetail.new_delivery_fee === 0 && shopDetail.delivery_fee_text">{{shopDetail.delivery_fee_text}}</span>
              <span v-else-if="shopDetail.new_delivery_fee || shopDetail.new_delivery_fee === 0">
                另需配送费￥{{ shopDetail.new_delivery_fee }}
              </span>
              <span v-else>另需配送费￥{{ shopDetail.delivery_fee }}</span>
              <span v-if="shopDetail.is_many_delivery == 1">起</span>
              <span v-if="shopDetail.is_self_take_new==1"> | 支持自提</span>
              <span v-if="shopDetail.is_eat_in==1"> | 堂食</span>
            </div>
            <div class="price" v-if="cartTotal>0">
              <span style="font-weight: bold;">￥{{ cartAmount }}</span>
              <span v-if="cartOriginAmount-cartAmount>0"
                    style="text-decoration: line-through;color:#797979;font-size: 0.2rem">￥{{ cartOriginAmount }}</span>
              <div class="tips"
                   v-if=" shopDetail.is_self_take_new == 1 && shopDetail.is_take_out == 0 && shopDetail.is_eat_in == 0">
                <span>只能打包自提</span></div>
              <div class="price tips"
                   v-if="shopDetail.is_self_take_new == 0 && (shopDetail.is_take_out == 0 && shopDetail.is_eat_in == 1)">
                <span>只能堂食</span></div>
              <div class="price tips"
                   v-if="shopDetail.is_self_take_new == 1 && (shopDetail.is_take_out == 0 && shopDetail.is_eat_in == 1)">
                <span>支持自提 | 堂食</span></div>
              <div class="tips" v-if="shopDetail.is_take_out == 1">
                <span v-if="shopDetail.new_delivery_fee === 0 && shopDetail.delivery_fee_text">{{shopDetail.delivery_fee_text}}</span>
                <span v-else-if="shopDetail.new_delivery_fee || shopDetail.new_delivery_fee === 0">
                  另需配送费￥{{ shopDetail.new_delivery_fee }}
                </span>
                <span v-else>另需配送费￥{{ shopDetail.delivery_fee }}</span>
                <span v-if="shopDetail.is_many_delivery == 1">起</span>
                <span v-if="shopDetail.is_self_take_new==1"> | 支持自提</span>
                <span v-if="shopDetail.is_eat_in==1"> | 堂食</span>
              </div>
            </div>
          </div>
          <div class="form-inline">
            <div class="btn btn-gray btn-lg fr" v-if="cartTotal<=0">去结算</div>
            <div v-else>
              <div @click="settleAccounts" class="btn btn-main btn-lg fr" v-if="spreadPrice<=0 && hasNeedChoose">
                去结算
              </div>
              <div @click="settleAccounts" class="btn btn-main btn-lg fr" style="font-size: .28rem"
                   v-if="spreadPrice<=0 && !hasNeedChoose">
                未点必选品
              </div>
              <div class="btn btn-gray btn-lg fr" v-if="spreadPrice > 0" style="font-size: 0.24rem">
                还差￥{{ spreadPrice }}起送
              </div>
            </div>
          </div>
        </footer>
      </div>
      <div v-else>
        <footer class="fixed closeShop">
          <p>店铺打烊，请其他方式下单或电话联系</p>
        </footer>
      </div>
      <!--购物车弹框-->
      <div class="mask" v-if="propShow" @click="toggleProp('cart')"></div>
      <div class="prop-box cart-list" v-if="propShow">
        <div v-if="cartInfo[shopCode].total>0">
          <!--购物车不为空-->
          <div class="promotion_reduce_tips" v-if="shopDetail.promotion_reduce && !hasSpecial">
            <div v-if="nextFullReductionAmountGap != ''">
              <span v-if="reductionAmount != ''">已减{{ reductionAmount }}元，</span>再买<span
              class="red">{{ nextFullReductionAmountGap }}元 </span>减<span
              class="red"> {{ nextFullReductionAmount }}元</span>
            </div>
            <div v-else-if="nextFullReductionAmountGap == ''">
              <span v-if="reductionAmount != ''">已减{{ reductionAmount }}元</span>
            </div>
          </div>
          <div class="promotion_reduce_tips" v-else-if="hasSpecial && reductionAmount > 0">
            <span>特价折扣优惠{{ reductionAmount }}元</span>
          </div>
        </div>
        <div v-else>
          <!--购物车为空-->
          <div class="promotion_reduce_tips"
               v-if="shopDetail.promotion_reduce && shopDetail.promotion_reduce.reduce_info.length>0  && !hasSpecial">
            {{ shopDetail.promotion_reduce.promotion_name }}
          </div>
        </div>
        <div class="title" style="overflow: hidden">
          <div class="flex-row-sc fl" @click="viewPackDesc()" v-if="cartInfo[shopCode].packFee > 0">
            <!--<div class="icon-pack"><span></span></div>-->
            <div class="fs-24" style="padding: 0 .1rem;">打包费<span
              class="red">¥{{ cartInfo[shopCode].packFee }}</span></div>
            <span class="icon-desc">?</span>
          </div>
          <span class="icon icon-delete fr" @click="clearCart">清空</span>
        </div>
        <ul>
          <li v-for="item in shopCartInfo">
            <div class="rol goods-name" style="width: 30%;">
              {{ item.gdName }}
              <div class="tip" v-if="item.specAttrStr">{{ item.specAttrStr }}</div>
            </div>
            <span class="rol pr">￥{{ item.singleTotalPrice }}</span>
            <del class="rol pr" v-if="item.activityId>0 && item.activeBuyNum > 0">￥{{ item.singleOriginPrice }}</del>
            <div class="rol num-box">
              <span class="btns minusBtn icon-removecart" @click="minusGoods(item)"></span>
              <span class="box">{{ item.cartNum }}</span>
              <span v-if="!item.noStock" class="btns addBtn icon-addtocart" @click="addGoods(item)"></span>
              <span v-else class="btns addBtn icon-cantaddtocart"></span>
            </div>
          </li>
        </ul>
      </div>
      <!--活动详情弹框-->
      <div class="mask over" v-if="propShopInfo" @click="toggleProp('shopInfo')" @touchmove.prevent></div>
      <div class="alert-box info" v-if="propShopInfo" @touchmove.prevent>
        <div class="shop-img" :style="{backgroundImage: 'url('+shopDetail.pic+')'}"></div>
        <div class="shop-name">{{ shopDetail.shop_name }}</div>
        <CommentStars :qualityCode="shopDetail.score"></CommentStars>
        <span>{{ shopDetail.score }}</span>
        <span style="padding: 0 .05rem;color: #E3E3E3;">|</span>
        <span>月售{{ shopDetail.sales_append }}单</span>
        <div class="otherInfo" style="display: flex;justify-content: center;font-size: .22rem">
          <div>起送 ￥{{ shopDetail.threshold_amount }}</div>
          <div class="ml10">
            <span v-if="shopDetail.delivery_fee_text">{{ shopDetail.delivery_fee_text }}</span>
            <template v-else>
              <span>配送￥</span>
              <span v-if="shopDetail.new_delivery_fee || shopDetail.new_delivery_fee === 0">
                    {{ shopDetail.new_delivery_fee }}
                  </span>
              <span v-else>{{ shopDetail.delivery_fee }}</span>
              <span v-if="shopDetail.is_many_delivery == 1">起</span>
            </template>
            <del v-if="shopDetail.new_delivery_fee || shopDetail.new_delivery_fee === 0">￥{{ shopDetail.delivery_fee }}</del>
          </div>
<!--          <div class="ml10" v-if="shopDetail.new_delivery_fee || shopDetail.new_delivery_fee === 0">-->
<!--            配送￥{{ shopDetail.new_delivery_fee }}-->
<!--            <span v-if="shopDetail.is_many_delivery == 1">起</span>-->
<!--            <del>￥{{ shopDetail.delivery_fee }}</del>-->
<!--          </div>-->
<!--          <div class="ml10" v-else>-->
<!--            配送￥{{ shopDetail.delivery_fee }}-->
<!--            <span v-if="shopDetail.is_many_delivery == 1">起</span>-->
<!--          </div>-->
          <span class="ml10" v-if="shopDetail.delivery_type == 1">(商家配送)</span>
<!--          <span class="ml10">月售{{ shopDetail.sales_append }}单</span>-->
          <span class="punctual-arrive ml10" v-if="shopDetail.zsd">{{shopDetail.zsd}}</span>
        </div>
        <div class='special-box' @touchmove.stop style="max-height: 50vh;overflow-y: scroll;overflow-scrolling: touch;-webkit-overflow-scrolling: touch;">
          <div class="special-goods"
               v-if="shopDetail.promotion_reduce && shopDetail.promotion_reduce.reduce_info.length>0"
               :style="{backgroundImage:'url('+shopDetail.promotion_reduce.icon_url+')'}">
            <span>{{ shopDetail.promotion_reduce.promotion_name }}</span>
          </div>
          <div class="special-goods" v-if="shopDetail.promotion_list && shopDetail.promotion_list.length>0"
               v-for="item in shopDetail.promotion_list" :style="{backgroundImage:'url('+item.icon_url+')'}">
            <span>{{ item.promotion_name }}</span>
          </div>
        </div>
        <div class="shopNoticeBox" v-if="shopDetail.announcement">
          <h3>公告</h3>
          <div class="special-box" style="border-top:none;padding-top:0">{{ shopDetail.announcement }}</div>
        </div>
        <div class="close-box shop-details" @click="toggleProp('shopInfo')"></div>
      </div>
      <!--商品详情弹框-->
      <div class="mask over" v-if="propGoodInfo" @click="toggleProp('goodInfo')" @touchmove.prevent></div>
      <div class="alert-box info goods" v-if="propGoodInfo" @touchmove.prevent>
        <img :src="goodsDetail.image_url"/>
        <div class="pad">
          <div class="good-name">{{ goodsDetail.goods_name }}</div>
          <div class="des">
            <span v-if="goodsDetail.activity_specification">{{ goodsDetail.activity_specification }} | </span>
            销量 {{ goodsDetail.sales_volume }} | 好评率 {{ goodsDetail.praise_rate }}%
          </div>
          <div class="price-box flexrow" style="justify-content: space-between">
            <div>
              <span class="price">￥{{ goodsDetail.activity_price }}</span>
              <del v-if="goodsDetail.activity_id>0">￥{{ goodsDetail.price }}</del>
            </div>
            <div v-if="shopDetail.is_open == 1">
              <div class="num-box" v-if="goodsDetail.sales_status == 1 && goodsDetail.stock > 0">
                <div v-if="goodsDetail.is_options == 1" class="btn-yellow select-spec-btn"
                     @click.stop="toggleProp('specInfo',goodsDetail)">
                  <span>选规格</span>
                  <!--<span v-else>选属性</span>-->
                  <span class="num" v-if="goodsDetail.cartNum>0">{{ goodsDetail.cartNum }}</span>
                </div>
                <div v-else>
                  <span class="btns minusBtn icon-removecart" @click.stop="minusGoods(goodsDetail)"
                        v-if="goodsDetail.cartNum>0"></span>
                  <span class="box" v-if="goodsDetail.cartNum>0">{{ goodsDetail.cartNum }}</span>
                  <span v-if="!goodsDetail.noStock" class="btns addBtn icon-addtocart"
                        @click.stop="addGoods(goodsDetail)"></span>
                  <span v-else class="btns addBtn icon-cantaddtocart"></span>
                </div>

              </div>
              <span class="num-box sales-out" v-else>售罄</span>
            </div>
          </div>
          <div class="sale-box" v-if="goodsDetail.activity_desc">
            <span class="no-bg">{{ goodsDetail.activity_desc }}</span>
            <span class="bg"
                  v-if="goodsDetail.activity_id > 0 && goodsDetail.sales_status == 1 && goodsDetail.left_stock<=10">剩{{
                goodsDetail.left_stock
              }}份</span>
          </div>
          <div v-if="goodsDetail.detail"
               style="color: #9b9b9b;font-size: .26rem;margin-top: .1rem;word-break: break-all;">
            {{ goodsDetail.detail }}
          </div>
        </div>
        <div class="close-box" @click="toggleProp('goodInfo')"></div>
      </div>
      <div class="mask" v-if="previewPic" @click="previewPic = false" @touchmove.prevent>
        <div class="pic-preview">
          <img :src="previewImgUrl" @click="previewPic = false">
        </div>
      </div>
      <!--选规格-->
      <div class="mask over" v-if="propSpecInfo" @click="toggleProp('specInfo',goodsDetail)" @touchmove.prevent></div>
      <div class="prop-box spec" v-if="propSpecInfo">
        <div class="spec-close-btn" @click="propSpecInfo=false"></div>
        <div class="goods-info flexrow">
          <img :src="goodsDetail.image_url"/>
          <div class="flexcol goods-des">
            <div class="ellipse" style="font-size: 0.3rem; color:#4A4A4A;font-weight: bolder">
              {{ goodsDetail.goods_name }}
            </div>
            <div class="goods-spec">已选: {{ goodsDetail.specAttrStr }}</div>
            <div class="red" v-if="goodsDetail.activity_id>0">
              ￥{{ goodsDetail.activity_price }}
            </div>
            <div class="red" v-else>￥{{ goodsDetail.sales_price }}</div>
          </div>
        </div>
        <div class="spec-content">
          <div class="spec-params"
               v-if="goodsDetail.sku_list[0].specification && goodsDetail.sku_list[0].specification != ''">
            <p style="margin-top: 0.1rem">规格</p>
            <ul class="flexrow">
              <li
                v-for="item in goodsDetail.sku_list"
                @click="handleSelect('spec',item)"
                :class="[{'selected': item.is_selected == 1},{'disabled-spec': item.is_can_choose == 0}]">
                {{ item.specification }}￥{{ item.sales_price }}
              </li>
            </ul>
          </div>
          <div class="spec-params" v-for="item in goodsDetail.attribute_list">
            <p>
              {{ item.attributeTypeName }}
              <span v-if="item.addPrice == 1">({{ item.selectTips }})</span>
            </p>
            <ul class="flexrow">
              <li
                v-for="item2 in item.attributeList"
                @click="handleSelect('attr',item2,item)"
                :class="[{'selected': item2.is_selected},{'disabled-spec': item2.saleStatus === 0}]">
                <span v-if="item.addPrice == 1">{{ item2.name }}¥{{ item2.salePrice }}</span>
                <span v-else>{{ item2.name }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="goodsDetail.specifications.sales_status == 1 && goodsDetail.specifications.stock != 0"
             class="btn-yellow select-spec-alert-btn fixed" @click="addGoods(goodsDetail)">选好了
        </div>
        <div v-else class="btn-gray select-spec-alert-btn fixed">售罄</div>

      </div>
      <!--购物车发生变化商品-->
      <div class="mask over" v-if="isShowCartGoods" @click="isShowCartGoods = false" @touchmove.prevent></div>
      <div class="alert-box change-goods" v-if="isShowCartGoods">
        <img @click="isShowCartGoods = false" src="../assets/images/close-icon-pay.png" alt=""
             style="width: .21rem; height: .21rem; float: right;">
        <div class="change-tit">以下商品发生了变化</div>
        <div class="change-sec-tit">你可以选购其他商品</div>
        <div v-for="(item, index) in changeGoodsInCart" :key="index" class="change-goods-item">
          <div class="ellipse" style="max-width: 2.8rem;">{{ item.name }}</div>
          <span v-if="item.num == 0">下架/售罄</span>
          <span v-if="item.num > 0">{{ item.message ? item.message : ('仅剩' + item.num + '份') }}</span>
        </div>
        <div class="btn-yellow change-goods-btn" @click="isShowCartGoods = false">重新选购</div>
      </div>
      <!-- 店铺优惠券弹出层 -->
      <div class="mask flex-row-cc" @click="closeCouponModal" v-if="couponModalOpened">
        <div class="dialog-coupon">
          <img :src="couponInfo.coupon_pic" style="width:100%"></img>
          <div class="coupon-box">
            <div class="card" v-for="item in couponInfo.coupon_list">
              <!--<img src="../assets/images/coupon-bg1.png" style="width:100%"></img>-->
              <div class="cnt flex-row-bc">
                <div>
                  <div class="fs-46 fc-red fw-bold">{{ item.couponName }}</div>
                  <div class="fs-26" style="color: #666;padding-top: .1rem">{{ item.couponDes }}</div>
                </div>
                <div style="width: 1.65rem">
                  <div class="fc-red ac fs-36">¥<span
                    class="fs-46 fw-bold fc-red">{{ item.couponAmount }}</span>{{
                      item.decimal ? '.' + item.decimal : ''
                    }}
                  </div>
                  <div class="get checked" v-if="item.status === 1">已领取</div>
                  <div class="get checked" v-if="item.status === 2">不可领</div>
                  <div class="get" v-if="item.status === 0" @click.stop="receiveCoupon(item)">点击领取</div>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="btn-receive" @click="receiveAllCoupons">一键领取</div>-->
        </div>
      </div>
    </div>
    <div v-if="showTip" class="sys_busy">
      <div class="my-content">
        <img src="../../src/assets/images/wait.png"/>
        <div>{{ tips }}</div>
        <!--        <div>系统开小差了，请返回重试～</div>-->
      </div>
    </div>
    <!-- 店铺内搜索 -->
    <div v-if="showShopSearch" class="shop-search-body">
      <div class="shop-header">
        <div class="back" @click="closeShopSearch()">
          <img src="../assets/images/icon_black_back.png" style="width: .18rem"/>
        </div>
        <div class="search-input">
          <img
            src="../assets/images/home_icon_search_bg.png"
            style="width: .28rem"
            mode="widthFix"
          />
          <input placeholder="想吃什么搜一搜" v-model="keyword" id="keyword" @blur="submitShopSearch()"/>
        </div>
      </div>
      <!--      <div class="search-input">-->
      <!--        <img-->
      <!--          src="../assets/images/home_icon_search_bg.png"-->
      <!--          style="width: .28rem"-->
      <!--          mode="widthFix"-->
      <!--        />-->
      <!--        <input placeholder="想吃什么搜一搜" v-model="keyword" id="keyword" @blur="submitShopSearch()"/>-->
      <!--      </div>-->
      <div class="search-list" v-if="searchResults.length > 0">
        <div style="padding-bottom: 100px">
          <ul class="goods-list">
            <li v-for="item2 in searchResults" style="border: none">
              <div class="goods-box" @click="toggleProp('goodInfo',item2)">
                <div class="goods-img">
                  <div class="lazy goodimg" :style="{backgroundImage: 'url('+item2.image_url+')'}"></div>
                </div>
                <div class="goods-des flexrow" style="padding-right: 0">
                  <div class="name">{{ item2.goods_name }}</div>
                  <p v-if="item2.activity_specification && item2.is_single_spec == 0">
                    {{ item2.activity_specification }}</p>
                  <p>销量 {{ item2.sales_volume }}</p>
                  <div class="flexrow" style="justify-content: space-between;align-items: center">
                    <p v-if="item2.activity_id>0">
                      <span class="price amounts" style="font-weight: bold;">￥{{ item2.activity_price }}</span>
                      <del>￥{{ item2.price }}</del>
                    </p>
                    <p v-else>
                      <span class="price amounts" style="font-weight: bold;">￥{{ item2.price }}</span>
                      <span v-if="item2.is_single_spec==0">起</span>
                    </p>
                    <div v-if="shopDetail.is_open == 1">
                      <div class="num-box" v-if="item2.sales_status == 1 && item2.stock > 0">
                        <div v-if="item2.is_options == 1" class="btn-yellow select-spec-btn"
                             @click.stop="toggleProp('specInfo',item2)">
                          <span>选规格</span>
                          <!--<span v-else>选属性</span>-->
                          <span class="num" v-if="item2.cartNum>0">{{ item2.cartNum }}</span>
                        </div>
                        <div v-else>
                        <span class="btns minusBtn icon-removecart" @click.stop="minusGoods(item2)"
                              v-if="item2.cartNum>0"></span>
                          <span class="box" v-if="item2.cartNum>0">{{ item2.cartNum }}</span>
                          <span v-if="item2.smallNumber > 1 && !item2.cartNum" class="btn-yellow select-spec-btn"
                                @click.stop="addGoods(item2)">{{ item2.smallNumber }}份起购</span>
                          <span v-else-if="!item2.noStock || item2.smallNumber <= 1 && !item2.cartNum"
                                class="btns addBtn icon-addtocart" @click.stop="addGoods(item2)"></span>
                          <span v-else class="btns addBtn icon-cantaddtocart"></span>
                        </div>

                      </div>
                      <span class="num-box sales-out" v-else>售罄</span>
                    </div>
                  </div>


                </div>
                <div class="sale-box" v-if="item2.activity_desc">
                      <span class="no-bg"
                            v-if="item2.activity_desc && item2.activity_desc != ''">{{ item2.activity_desc }}</span>
                  <span class="bg"
                        v-if="item2.activity_id>0 && item2.sales_status == 1 && item2.left_stock<=10">剩{{
                    item2.left_stock
                  }}份</span>
                </div>

                <div style="padding-left: 1.26rem;margin-top: 0.1rem">
                      <span class="activity-tip"
                            v-if='item2.partner != 0 && item2.activity_desc_extra'>{{
                          item2.activity_desc_extra
                        }}</span>
                  <span class="activity-tip" v-if="item2.show_text">{{ item2.show_text }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>

      </div>
      <div v-if="iShowSearchNothing" class="nothing">抱歉，未能找到您搜索的商品</div>
    </div>
  </div>
</template>
<script>
// var wx = require('weixin-js-sdk')
import {actions} from '../store/actions'
import PreviewPicture from '../components/PreviewPicture.vue'
import CommentStars from '../components/CommentStars'
import IScroll from '../assets/js/iscroll-probe.js'
import _ from "lodash";
// import { MessageBox, Toast, Indicator} from 'mint-ui'

var myScroll;
var myScroll1;

export default {
  name: 'index',
  data() {
    return {
      spreadPrice: '',
      thresholdAmount: '',
      propShow: false,
      goodsList: [],
      myGoodsList:[], //超市商品列表
      req_type: 0, //是否是超市
      isClickSupperTag: false,
      isFromSupperPage: false,
      cartInfoTags:  new Map(),
      page: 0,
      noMore: false,
      isLoading: false,
      myIndex: 0,
      shopDetail: {
        promotion_list: []
      },
      goodsDetail: {},
      shopCartInfo: [],
      cartTotal: 0,
      cartAmount: 0,//商品总价
      cartOriginAmount: 0,//商品总原价
      showBlock: 'orderDishes',
      propShopInfo: false,
      propGoodInfo: false,
      propSpecInfo: false,
      CommentNum: '',
      businessCommentList: [],
      activeGoodsNum: 0,
      activeGoodsArray: [], // 购物车内活动商品
      flag: true,
      showPage: false,
      shopCode: '',
      shopUrl: window.location.href,
      landingPage: window.localStorage.getItem('landingPage'),
      openTime: '',
      orderType: '',
      hasSpecial: false,
      reductionAmount: '',//已减金额
      nextFullReductionAmount: 0,//下一满足金额
      nextFullReductionAmountGap: '',//距下一满足金额差额
      previewPic: false,//图片预览弹框
      previewImgUrl: '',//预览图片url
      specification: {},//规格
      attributes: [],//属性
      orderCode: '',

      hasNeedChoose: false, //是否包含必点商品
      needChooseCates: [], // 必选分类组
      needChooseCatesIds: [],
      isShowCartGoods: false,
      changeGoodsInCart: [],

      couponModalOpened: false, //店铺优惠券弹框
      couponInfo: {},
      tips: '',
      showTip: false,

      keyword: '',
      searchResults: [],
      showShopSearch: false,
      iShowSearchNothing: false,

      gdCode: 0,
    }
  },
  computed: {
    cartInfo() {
      return this.$store.state.cartInfo
    },
    schoolInfo() {
      return this.$store.state.schoolInfo
    },
    wxUid() {
      return this.$store.state.wxUid
    },
    wxLoginToken() {
      return this.$store.state.wxLoginToken
    }
  },
  created() {
    var _this = this;

    // if(_this.isIos && !_this.$utils.resolveUrl().isShare && document.domain.indexOf('xiyoushi.com') < 0) {
    //   window.history.replaceState({}, '', _this.landingPage);
    // }

    if (!window.localStorage.getItem('cartInfo')) {
      var cartInfo = {};
      _this.$store.commit('changeCartInfo', cartInfo)
    }

    if (window.localStorage.getItem('showBlockType')) {
      _this.showBlock = window.localStorage.getItem('showBlockType')
    }

    // 更新用户详细信息
    var token = window.localStorage.getItem('wxToken')
    if (_this.$utils.getCookie('token')) {
      token = _this.$utils.getCookie('token')
      var obj = {
        wxToken: token
      }
      _this.$store.commit('changeState', obj)
      // _this.updateUserInfo(token);
    }

    if (_this.$utils.resolveUrl().shopCode) {
      _this.shopCode = _this.$utils.resolveUrl().shopCode;
      var obj = {
        shop_code: _this.$utils.resolveUrl().shopCode,
      };
      _this.getShopInfo()
      // localStorage.removeItem('urlSource');
      // 来源：上海现代高校智慧后勤研究院
      // let urlSource = _this.$utils.resolveUrl().source;
      // if (urlSource && urlSource == 'yjy') {
      //   localStorage.setItem('urlSource','yjy');
      // }
    } else {
      _this.shopCode = window.localStorage.getItem('shop_code');
      _this.getShopInfo()
    }

    if (_this.$utils.resolveUrl().gdCode) {
      _this.gdCode = _this.$utils.resolveUrl().gdCode;
    }

    if (!_this.cartInfo[_this.shopCode]) {
      _this.cartInfo[_this.shopCode] = {
        total: 0,
        amount: 0,
        market: {}
      };
      _this.$store.commit('changeCartInfo', _this.cartInfo)
    }

    if (_this.cartInfo[_this.shopCode].total) {
      _this.cartTotal = _this.cartInfo[_this.shopCode].total;//初始化购物车商品数量
      _this.cartAmount = _this.cartInfo[_this.shopCode].amount;//初始化页面购物车金额
      _this.isFromSupperPage =  true
      let data = Object.values(_this.cartInfo[_this.shopCode].market)
      let arr = new Map()
      for(let i = 0; i < data.length; i++){
        for(let item of data[i]){
          if(arr.has(item.tag_id1)){
            let num  = arr.get(item.tag_id1) + item.cartNum
            arr.set(item.tag_id1,num)
          }else{
            arr.set(item.tag_id1,item.cartNum)
          }
        }
      }
      _this.cartInfoTags = arr
    }
    _this.orderCode = _this.$route.params.orderCode;
    if (_this.orderCode) {
      if (_this.cartTotal > 0) {
        _this.propShow = true
      }
      _this.changeGoodsInCart = JSON.parse(window.localStorage.getItem('changeGoodsInCart'))
      if (_this.changeGoodsInCart.length > 0) {
        _this.isShowCartGoods = true
      }
    }
    _this.addLog();
    window.localStorage.removeItem('selectedCoupon')
    window.localStorage.removeItem('selectedDeliveryCoupon')
  },
  methods: {
    updateUserInfo(token) {
      var _this = this;
      actions.postAuthInfo(_this, {token: token}, function (data) {
        let openid = _this.$store.state.openId
        if (data.openid && data.openid != '') {
          openid = data.openid
        }
        if(data.login_token){
          let obj = {
            openId: openid,
            wxUid: data.uid,
            wxToken: data.token,
            wxLoginToken: data.login_token,
            platformType: data.platform_type
          }
          _this.$store.commit('changeState', obj)

          let userInfo = {
            avatar: data.avatar || data.headimgurl,
            nickname: data.nickname,
            mp: data.mp,
            sex: data.sex,
            mp_real: _this.$utils.Decrypt(data.mp_encryption),
          }
          _this.$store.commit('changeUserInfo', userInfo)
        }
      })
    },
    addLog(param) {
      // 内部统计
      var _this = this;
      var params = param || {
        logDetails: [
          {
            uid: _this.$store.state.wxUid == 'undefined' ? 0 : _this.$store.state.wxUid,
            code: 'aly_wechat_shop',
            createTime: new Date().getTime(),
            refId: localStorage.getItem('shop_code'),
            firstValue: this.$utils.getCookie('UM_distinctid')
          },
          {
            uid: _this.$store.state.wxUid == 'undefined' ? 0 : _this.$store.state.wxUid,
            code: 'display_takeout_shop_index',
            createTime: new Date().getTime(),
            refId: localStorage.getItem('shop_code'),
            firstValue: this.$utils.getCookie('UM_distinctid')
          },
        ],
        source: 3,
      }
      actions.postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {

      })
    },
    // 图片预览
    picPreview(e) {
      this.previewPic = true;
      this.previewImgUrl = e.target.currentSrc;
    },

    showMoreGift: function () {
      this.shopDetail.iShowMore = !this.shopDetail.iShowMore
    },
    switchInfo: function (e) {
      var _this = this
      if (e.target.id == 'orderDishes') {
        _this.showBlock = 'orderDishes';
        _this.flag = true;
        window.localStorage.setItem('showBlockType', 'orderDishes');
        if(_this.shopDetail.req_type){
          _this.myGoodsList.forEach( item => {
              item.goods_list = []
          })
          _this.isClickSupperTag = true
          _this.isFromSupperPage = true
          _this.getShopTagList(0,_this.defaultGoodsList[0].tag_id,_this.defaultGoodsList[0].is_special_tag)
        }else{
          _this.getGoodsList()
        }
      } else if (e.target.id == 'commentInfo') {
        _this.showBlock = 'commentInfo';
        window.localStorage.setItem('showBlockType', 'commentInfo');
        _this.getBusinessCommentList()
      } else if (e.target.id == 'shopInfo') {
        _this.showBlock = 'shopInfo';
        window.localStorage.setItem('showBlockType', 'shopInfo')
      }
      // _this.$nextTick(function () {
      //   var height = window.innerHeight;
      //   var topAreaHeight = document.getElementById("topArea").scrollHeight;
      //   var checkTab = document.getElementById("checkTab").scrollHeight;
      //
      //   if (e.target.id == 'orderDishes') {
      //     //给页面最底部的ul加最小高度，保证页面能滚动到相应位置
      //     var goodList = document.getElementById("goodList");
      //     var botHeight = document.getElementsByTagName('footer')[0].clientHeight;
      //     goodList.style.height = (height - botHeight - topAreaHeight - checkTab) + 'px';
      //     goodList.lastChild.style.minHeight = (height - topAreaHeight - botHeight - checkTab) + 'px';
      //   } else {
      //     var content3 = document.getElementById("content3");
      //     content3.style.height = (height - topAreaHeight - checkTab) + 'px';
      //   }
      // })
    },
    //获取店铺分类列表信息
    getShopTagList(sortType,tagCode,specialTag){
      var _this = this
      _this.$indicator.open();
      this.noMore = false
      var params = {
        sortType: sortType,
        size: 20,
        tagCode: specialTag ? '' : tagCode,
        shopCode: _this.shopCode,
        specialTag: specialTag,
        token: _this.wxLoginToken
      };
      actions.getShopCodeList(_this, params, function (data) {
        _this.$indicator.close();
        if(data.goods_list && data.goods_list.length) {
          var val = _this.myGoodsList.findIndex(el=> data.goods_list[0].tag_id == el.tag_id)
          if(val != -1){
            _this.myGoodsList[val].goods_list = _this.myGoodsList[val].goods_list.concat(data.goods_list)
            _this.myGoodsList[val].codes = data.codes
          }
          if(data.goods_list.length < 20){
            _this.noMore = true
          }else{
            _this.isLoading = false
          }
          _this.getGoodsList1();
          _this.$forceUpdate()
        }else{
          _this.noMore = true
          _this.$forceUpdate()
        }
      })
    },
    getDetailGoods(specialTag,index){
      var _this = this
      let nums = _this.myGoodsList[index].codes.length - 20*_this.page
      _this.page++;
      var codesList = nums >= 20 ? _this.myGoodsList[index].codes.slice(20*_this.page,20*_this.page + 20) : _this.myGoodsList[index].codes.slice(20*_this.page,20*_this.page+nums)
      if(codesList.length){
        _this.$indicator.open();
        var params = {
          codes: codesList,
          shopCode: _this.shopCode,
          specialTag: specialTag,
          token: _this.wxLoginToken
        };
        actions.getShopDetailList(_this, params, function (data) {
          _this.$indicator.close();
          if(data.goods_list && data.goods_list.length){
            var val = _this.myGoodsList.findIndex(el=> data.goods_list[0].tag_id == el.tag_id)
            if(val != -1){
              _this.myGoodsList[val].goods_list = _this.myGoodsList[val].goods_list.concat(data.goods_list)
            }
            if(data.goods_list.length < 20){
              _this.noMore = true
            }else{
              _this.isLoading = false
            }
            _this.$forceUpdate()
          }
        })
      }else{
        _this.noMore = true
        _this.$forceUpdate()
      }

    },
    // 获取店铺所有信息
    getShopInfo: function () {
      var _this = this
      _this.$indicator.open();
      // 获取商品列表接口
      var params = {
        shop_id: _this.shopCode,
        token: _this.wxLoginToken
      };
      actions.getGoodsList(_this, params, function (data) {
        _this.$indicator.close();
        data.shop_detail.isShowMore = false;
        _this.showPage = true;
        for (let item of data.item_list) {
          if (item.is_single_spec == 1) {//单规格商品
            item.sku_id = item.sku_list[0].sku_id
          }
          if (item.type == 1) {
            _this.needChooseCates.push({tag_id: item.tag_id, tag_name: item.tag_name});
            _this.needChooseCatesIds.push(item.tag_id);
          }
        }
        _this.defaultGoodsList = data.item_list; //商品数据
        let schoolInfo = {
          schoolId: data.shop_detail.school_id,
          schoolName: data.shop_detail.school_name
        }
        _this.$store.commit('changeSchoolInfo', schoolInfo)

        // 活动展示
        let promotion_list1 = [];
        if (data.shop_detail.promotion_reduce && data.shop_detail.promotion_reduce.reduce_info) {
          for (let r of data.shop_detail.promotion_reduce.reduce_info) {
            promotion_list1.push(`${r.meet_price}减${r.cut_price}`)
          }
        }
        if (data.shop_detail.promotion_list && data.shop_detail.promotion_list.length > 0) {
          let promotion_list = data.shop_detail.promotion_list;
          for (let p of promotion_list) {
            promotion_list1.push(p.promotion_tips);
          }
        }
        if (promotion_list1.length > 0) {
          data.shop_detail.promotion_list1 = [...new Set(promotion_list1)];
        }

        if (data.shop_detail.aptitude) {
          let aptitude = data.shop_detail.aptitude;
          if (aptitude.license_list && aptitude.license_list.length > 0) {
            aptitude.license_url_list = [];
            for (let v of aptitude.license_list) {
              aptitude.license_url_list.push(v.license);
            }
          }
          if (aptitude.food_license_list && aptitude.food_license_list.length > 0) {
            aptitude.food_license_url_list = [];
            for (let v of aptitude.food_license_list) {
              aptitude.food_license_url_list.push(v.food_license);
            }
          }
        }

        _this.shopDetail = data.shop_detail;//店铺信息
        // 券包埋点
        if(_this.shopDetail.promotion_package && _this.shopDetail.promotion_package.length > 0){
          var clickParams = [{
            uid: _this.$store.state.wxUid,
            code: 'asa_shop_coupon_bag',
            createTime: new Date().getTime(),
            refId: _this.shopDetail.promotion_package[0].promotion_id,
            firstValue: _this.schoolInfo.schoolId,
            secondValue: _this.shopCode
          }]
          _this.addLog1(clickParams);
        }
        document.title = _this.shopDetail.shop_name;//页面title
        if (_this.shopDetail.open_rules == 0) {//店铺营业时间格式展示处理
          let open_time = []
          for (let item of data.shop_detail.open_setting) {
            let str = item.begin_time + '-' + item.end_time
            open_time.push(str)
          }
          _this.openTime = open_time.join('、')

        }
        _this.thresholdAmount = data.shop_detail.threshold_amount; //店铺配送费

        window.localStorage.setItem('shopType', _this.shopDetail.is_self_take_new);//是否支持自提 0 否 ，1是
        window.localStorage.setItem('is_take_out', _this.shopDetail.is_take_out);//是否支持外卖 0 否 ，1是
        window.localStorage.setItem('is_eat_in', _this.shopDetail.is_eat_in);//是否支持堂食 0 否 ，1是
        if(_this.shopDetail.req_type){
          _this.req_type = 1
          _this.myGoodsList = JSON.parse(JSON.stringify(_this.defaultGoodsList))
          _this.myGoodsList.forEach( item => {
            if(!item.goods_list){
              item.goods_list = []
              item.codes = []
            }
          })
          _this.isClickSupperTag = true
          _this.getShopTagList(0,_this.defaultGoodsList[0].tag_id,_this.defaultGoodsList[0].is_special_tag)
        }else{
          _this.getGoodsList();
        }
        _this.getTotalPrice();
        _this.getGrantlist(1);
        if (_this.shopDetail.is_take_out == 1) {
          _this.orderType = 0 //外卖
        } else if (_this.shopDetail.is_self_take_new == 1 && (_this.shopDetail.is_take_out == 0 && _this.shopDetail.is_eat_in == 0)) {
          _this.orderType = 1 //仅自提
        } else if (_this.shopDetail.is_eat_in == 1 && (_this.shopDetail.is_self_take_new == 0 && _this.shopDetail.is_take_out == 0)) {
          _this.orderType = 3 //仅堂食
        } else if ((_this.shopDetail.is_self_take_new == 1 && _this.shopDetail.is_eat_in == 1) && _this.shopDetail.is_take_out == 0) {
          _this.orderType = 1 //自提+堂食
        }
        // 自定义分享
        let host = _this.$utils.getHost();
        let link = _this.$utils.isWxWork() ? (host + '/wxWork') : _this.$utils.getAgentApiHost() + '/wechat/auth/enter?redirect=goodslist&data=' + encodeURIComponent(JSON.stringify({'shopCode': _this.shopCode}));
        _this.$utils.wxShareNew(
          _this,
          _this.shopDetail.shop_name, // 分享标题
          link, // 分享链接
          _this.shopDetail.pic, // 分享图标
          '订餐首选俺来也，美味餐食极速送达，爱吃节最低2.7元' // 分享描述
        );
      }, function (data) {
        _this.$indicator.close();
        if (data.body.flag == -202) {
          _this.tips = data.body.message
          _this.showTip = true;
        } else {
          _this.$messagebox.alert(data.body.message, '');
        }

      })

    },
    // 展示刷新商品列表
    getGoodsList1: function () {
      var _this = this
      var list = _this.myGoodsList //取默认数据
      let data = Object.values(_this.cartInfo[_this.shopCode].market)
      let arr = new Map()
      for(let i = 0; i < data.length; i++){
        for(let item of data[i]){
          if(arr.has(item.tag_id1)){
            let num  = arr.get(item.tag_id1) + item.cartNum
            arr.set(item.tag_id1,num)
          }else{
            arr.set(item.tag_id1,item.cartNum)
          }
        }
      }
      _this.cartInfoTags = arr
      if (list.length > 0) {
        //判断购物车中是否有商品
        if (JSON.stringify(_this.cartInfo[_this.shopCode].market) == "{}") { //购物车无商品
          //遍历接口返回的商品列表，添加cartNum属性
          for (var g in list) {
            //侧边栏名字显示字数控制
            if (list[g].tag_name.length > 7) {
              list[g].tag_name_short = list[g].tag_name.substring(0, 7) + "...";
            } else {
              list[g].tag_name_short = list[g].tag_name;
            }
            list[g].tagNum = 0
            var goodsList = list[g].goods_list
            if(goodsList && goodsList.length){
              for (var e in goodsList) {
                goodsList[e].cartNum = 0
                goodsList[e].cateType = list[g].type;
              }
            }
          }
        } else {//购物车有商品，则遍历购物车中商品，取出商品id,组成数组
          var goodsCodes = [];
          for (var pa in _this.cartInfo[_this.shopCode].market) {
            goodsCodes.push(pa)
          }

          //判断库存是否还有
          for (var key in _this.cartInfo[_this.shopCode].market) {
            for (let obj of _this.cartInfo[_this.shopCode].market[key]) {
              if (obj.stock <= obj.cartNum) {
                obj.noStock = true; //无库存
              } else {
                obj.noStock = false; //有库存
              }
            }
          }
          if(!_this.isClickSupperTag && !_this.isFromSupperPage){
            //修改当前侧边栏的商品
            list[_this.myIndex].tagNum = 0
            //侧边栏名字显示字数控制
            if (list[_this.myIndex].tag_name.length > 6) {
              list[_this.myIndex].tag_name_short = list[_this.myIndex].tag_name.substring(0, 7) + "...";
            } else {
              list[_this.myIndex].tag_name_short = list[_this.myIndex].tag_name;
            }
            var goodsList = list[_this.myIndex].goods_list
            if(goodsList && goodsList.length){
              for (let item of goodsList) {
                item.cateType = list[_this.myIndex].type;
                if (item.is_single_spec == 1) { //单规格商品
                  if (goodsCodes.indexOf(item.sku_list[0].sku_id) >= 0) {
                    let cartNum = 0;// 已有该商品id
                    for (let obj of _this.cartInfo[_this.shopCode].market[item.sku_list[0].sku_id]) {
                      cartNum += obj.cartNum
                    }
                    item.cartNum = cartNum
                  } else {// 无该商品id
                    item.cartNum = 0
                  }

                } else {//多规格商品
                  let cartNum = 0;
                  for (let obj of item.sku_list) {
                    if (goodsCodes.indexOf(obj.sku_id) >= 0) {
                      for (let obj2 of _this.cartInfo[_this.shopCode].market[obj.sku_id]) {
                        cartNum += obj2.cartNum
                      }
                    }
                  }
                  item.cartNum = cartNum
                }
                list[_this.myIndex].tagNum += item.cartNum
              }
            }
          }else if(_this.isClickSupperTag){
            for (var g in list) {
              list[g].tagNum = 0
              //侧边栏名字显示字数控制
              if (list[g].tag_name.length > 6) {
                list[g].tag_name_short = list[g].tag_name.substring(0, 7) + "...";
              } else {
                list[g].tag_name_short = list[g].tag_name;
              }
              var goodsList = list[g].goods_list
              if(goodsList && goodsList.length){
                for (let item of goodsList) {
                  item.cateType = list[g].type;
                  if (item.is_single_spec == 1) { //单规格商品
                    if (goodsCodes.indexOf(item.sku_list[0].sku_id) >= 0) {
                      let cartNum = 0;// 已有该商品id
                      for (let obj of _this.cartInfo[_this.shopCode].market[item.sku_list[0].sku_id]) {
                        cartNum += obj.cartNum
                      }
                      item.cartNum = cartNum
                    } else {// 无该商品id
                      item.cartNum = 0
                    }

                  } else {//多规格商品
                    let cartNum = 0;
                    for (let obj of item.sku_list) {
                      if (goodsCodes.indexOf(obj.sku_id) >= 0) {
                        for (let obj2 of _this.cartInfo[_this.shopCode].market[obj.sku_id]) {
                          cartNum += obj2.cartNum
                        }
                      }
                    }
                    item.cartNum = cartNum
                  }
                  list[g].tagNum += item.cartNum
                  _this.isClickSupperTag = false
                }
              }
            }
            if(_this.isFromSupperPage) {
              for(let v in list){
               list[v].tagNum = _this.cartInfoTags.get(list[v].tag_id + '') || 0
              }
              _this.isFromSupperPage = false
            }
          }
        }
      }
      _this.myGoodsList = list;
      if (_this.flag) {
        _this.$nextTick(function () {

          _this.flag = false

          // 页面渲染完成后，计算页面元素高度
          var height = window.innerHeight;
          var botHeight = document.getElementsByTagName('footer')[0].clientHeight;
          var navBox = document.getElementById("scrollBox1");
          var goodList = document.getElementById("goodList");
          var topAreaHeight = document.getElementById("topArea").scrollHeight;
          var checkTab = document.getElementById("checkTab").scrollHeight;
          var navBoxChild = navBox.children;

          //默认第一个tab高亮
          if (navBoxChild.length > 0) {
            for(var k = 1; k < navBoxChild.length; k++){
              navBoxChild[k].className = "";
            }
            navBoxChild[0].className = "active";
          }

          //给页面最底部的ul加最小高度，保证页面能滚动到相应位置
          goodList.style.height = (height - botHeight - topAreaHeight - checkTab) + 'px';
          myScroll1 = new IScroll('#goodList', {
            bounce: false,
            mouseWheel: true,
            // scrollbars: true,
            // preventDefault: false,//（把这句加上去哦）
            preventDefaultException: {tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|SPAN|A|DIV)$/},  //（这个后面加|A,因为iscroll阻止了A的默认事件）
            probeType: 3
          });
          _this.flag = false

          myScroll1.on('scrollEnd', function () {
            var scrollTop = Math.abs(this.y);
            //当导航与相应文档接触的时候加载下一页
            //method1
            if (scrollTop == Math.abs(this.maxScrollY) && (this.directionY === 1) && !_this.noMore && !_this.isLoading) {
              console.log('滚动到底部');
              _this.isLoading = true
              _this.getDetailGoods(_this.myGoodsList[_this.myIndex].is_special_tag,_this.myIndex)
            }
            setTimeout(function(){//放在计时器里边才好使，不然容易出错
              myScroll1.refresh();
            },0)
          })

        })
      }
      // 同步搜索
      if (_this.showShopSearch) {
        if (_this.searchResults.length > 0) {
          let searchResults = _this.searchResults;
          for (let v of _this.myGoodsList) {
            for (let v1 of v.goods_list) {
              for (let s of searchResults) {
                if (s.gd_code == v1.gd_code) {
                  s = v1;
                }
              }
            }
          }
          _this.searchResults = searchResults;
        }
      }
    },

    // 展示刷新商品列表
    getGoodsList: function () {
      var _this = this
      var list = _this.defaultGoodsList //取默认数据
      if (list.length > 0) {
        //判断购物车中是否有商品
        if (JSON.stringify(_this.cartInfo[_this.shopCode].market) == "{}") { //购物车无商品
          //遍历接口返回的商品列表，添加cartNum属性
          for (var g in list) {
            //侧边栏名字显示字数控制
            if (list[g].tag_name.length > 7) {
              list[g].tag_name_short = list[g].tag_name.substring(0, 7) + "...";
            } else {
              list[g].tag_name_short = list[g].tag_name;
            }
            var goodsList = list[g].goods_list
            for (var e in goodsList) {
              goodsList[e].cartNum = 0
              goodsList[e].cateType = list[g].type;
            }
            list[g].tagNum = 0
          }
        } else {//购物车有商品，则遍历购物车中商品，取出商品id,组成数组
          var goodsCodes = [];
          for (var pa in _this.cartInfo[_this.shopCode].market) {
            goodsCodes.push(pa)
          }

          //判断库存是否还有
          for (var key in _this.cartInfo[_this.shopCode].market) {
            for (let obj of _this.cartInfo[_this.shopCode].market[key]) {
              if (obj.stock <= obj.cartNum) {
                obj.noStock = true; //无库存
              } else {
                obj.noStock = false; //有库存
              }
            }
          }
          //遍历接口返回的商品列表，与商品id
          for (var g in list) {
            list[g].tagNum = 0
            //侧边栏名字显示字数控制
            if (list[g].tag_name.length > 6) {
              list[g].tag_name_short = list[g].tag_name.substring(0, 7) + "...";
            } else {
              list[g].tag_name_short = list[g].tag_name;
            }
            var goodsList = list[g].goods_list
            if(goodsList && goodsList.length){
              for (let item of goodsList) {
                item.cateType = list[g].type;
                if (item.is_single_spec == 1) { //单规格商品
                  if (goodsCodes.indexOf(item.sku_list[0].sku_id) >= 0) {
                    let cartNum = 0;// 已有该商品id
                    for (let obj of _this.cartInfo[_this.shopCode].market[item.sku_list[0].sku_id]) {
                      cartNum += obj.cartNum
                    }
                    item.cartNum = cartNum
                  } else {// 无该商品id
                    item.cartNum = 0
                  }

                } else {//多规格商品
                  let cartNum = 0;
                  for (let obj of item.sku_list) {
                    if (goodsCodes.indexOf(obj.sku_id) >= 0) {
                      for (let obj2 of _this.cartInfo[_this.shopCode].market[obj.sku_id]) {
                        cartNum += obj2.cartNum
                      }
                    }
                  }
                  item.cartNum = cartNum
                }
                list[g].tagNum += item.cartNum
              }
            }
          }
        }
      }
      _this.goodsList = list;
      setTimeout(function () {
        if(_this.gdCode){
          _this.goToGood()
        }
      },500)
      if (_this.flag) {
        _this.$nextTick(function () {

          _this.flag = false

          // 页面渲染完成后，计算页面元素高度
          var height = window.innerHeight;
          var botHeight = document.getElementsByTagName('footer')[0].clientHeight;
          var navBox = document.getElementById("scrollBox");
          var goodList = document.getElementById("goodList");
          var topAreaHeight = document.getElementById("topArea").scrollHeight;
          var checkTab = document.getElementById("checkTab").scrollHeight;
          var navBoxChild = navBox.children;
          var scroller = document.getElementById("scroller");
          var textChild = scroller.children;


          //默认第一个tab高亮
          if (navBoxChild.length > 0) {
            for(var k = 1; k < navBoxChild.length; k++){
              navBoxChild[k].className = "";
            }
            navBoxChild[0].className = "active";
          }

          //给页面最底部的ul加最小高度，保证页面能滚动到相应位置
          goodList.style.height = (height - botHeight - topAreaHeight - checkTab) + 'px';
          if (textChild.length > 0) {
            scroller.lastChild.style.minHeight = (height - topAreaHeight - botHeight - checkTab) + 'px';
          }

          myScroll = new IScroll('#goodList', {
            bounce: false,
            mouseWheel: true,
            // preventDefault: false,//（把这句加上去哦）
            preventDefaultException: {tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|SPAN|A|DIV)$/},  //（这个后面加|A,因为iscroll阻止了A的默认事件）
            probeType: 3
          });
          _this.flag = false


          myScroll.on('scroll', function () {
            var scrollTop = Math.abs(this.y);

            //当导航与相应文档接触的时候自动切换
            //method1
            if (scrollTop > 0) {
              for (var i = 0; i < navBoxChild.length; i++) {
                if (scrollTop >= textChild[i].offsetTop) {
                  for (var j = 0; j < navBoxChild.length; j++) {
                    navBoxChild[j].className = "";
                  }
                  navBoxChild[i].className = "active";
                }
              }
            }
          });

          myScroll.on('scrollEnd', function () {
            var scrollTop = Math.abs(this.y);
            //当导航与相应文档接触的时候自动切换
            //method1
            if (scrollTop > 0) {
              for (var i = 0; i < navBoxChild.length; i++) {
                if (scrollTop >= textChild[i].offsetTop) {
                  for (var j = 0; j < navBoxChild.length; j++) {
                    navBoxChild[j].className = "";
                  }
                  navBoxChild[i].className = "active";
                }
              }
            }
          })

        })
      }
      // 同步搜索
      if (_this.showShopSearch) {
        if (_this.searchResults.length > 0) {
          let searchResults = _this.searchResults;
          for (let v of _this.goodsList) {
            for (let v1 of v.goods_list) {
              for (let s of searchResults) {
                if (s.gd_code == v1.gd_code) {
                  s = v1;
                }
              }
            }
          }
          _this.searchResults = searchResults;
        }
      }
    },
    // 获取店铺评价
    getBusinessCommentList: function () {
      var _this = this
      _this.goodList = []
      _this.badList = []
      var params = {
        supplierId: _this.shopCode,
        pageNo: 1,
        pageSize: 10
      }
      actions.getBusinessCommentList(_this, params, function (data) {
        _this.CommentNum = data.total
        _this.businessCommentList = data.list
        for (var i = 0; i < _this.businessCommentList.length; i++) {
          _this.businessCommentList[i].goodList = []
          _this.businessCommentList[i].badList = []
          for (var m = 0; m < _this.businessCommentList[i].goodsMarkList.length; m++) {
            if (_this.businessCommentList[i].goodsMarkList[m].goodsScore == 2) {
              _this.businessCommentList[i].goodList.push(_this.businessCommentList[i].goodsMarkList[m].goodsName)
            } else if (_this.businessCommentList[i].goodsMarkList[m].goodsScore == 1) {
              _this.businessCommentList[i].badList.push(_this.businessCommentList[i].goodsMarkList[m].goodsName)
            }
          }
        }
      })
    },
    // 计算总价
    getTotalPrice: function () {
      var _this = this;
      var cartInfo = _this.cartInfo;
      var market = _this.cartInfo[_this.shopCode].market;
      var totalPrice = 0;//商品总价
      var activeGoods = []; //初始化购物车中所有活动商品数组
      var orderNumList = [];
      var originPrice = 0;//商品总原价
      var totalPackFee = 0; // 打包费
      let packFeeDetail = [];
      _this.hasSpecial = false;//购物车是否有特价商品：true是有
      _this.reductionAmount = '';
      _this.nextFullReductionAmount = 0;
      _this.nextFullReductionAmountGap = '';
      _this.activeGoodsNum = 0;//初始化购物车中活动商品的数量
      _this.activeGoodsArray = [];

      for (var key in market) {
        for (let item of market[key]) {
          if (item.activityId > 0) {
            orderNumList.push(item.orderNum);
            var obj = {};
            obj.gdName = item.gdName;
            obj.activityId = item.activityId;
            obj.sku_id = item.sku_id;
            obj.goodsNum = item.goodsNum; //商品限购数量
            obj.leftNum = item.leftNum;
            obj.cartNum = item.cartNum;
            obj.orderNum = item.orderNum;
            obj.priceGap = (parseFloat(item.salePrice) - parseFloat(item.activePrice)).toFixed(2);
            if (item.attrIdArr) {
              obj.attr_id = item.attrIdArr.join("-")
            }
            activeGoods.push(obj); //活动商品组
            _this.activeGoodsNum += item.cartNum;

            let exist = 0;
            for (let v of _this.activeGoodsArray) {
              if (v.activityId == item.activityId) {
                exist++;
                v.activityNums += item.cartNum;
                v.orderNum = Math.min(v.orderNum, item.orderNum);
              }
            }
            if (exist == 0) {
              _this.activeGoodsArray.push({
                activityId: item.activityId,
                activityNums: item.cartNum,
                orderNum: item.orderNum
              });
            }
          }
          item.activeBuyNum = 0;
        }
      }
      // console.log(_this.activeGoodsArray)
      // 同一个店铺支持多种活动
      for (let v of _this.activeGoodsArray) {
        if (v.orderNum) {
          if (v.activityNums <= v.orderNum) {
            for (var key in market) {
              for (let item of market[key]) {
                if (item.activityId > 0 && item.activityId == v.activityId) { //是特价商品
                  let activeBuyNum;
                  let buyNum = item.cartNum; //单个商品购买数量
                  let leftNum = item.leftNum; //活动商品剩余库存
                  let goodsNum = item.goodsNum; //活动商品限购数量
                  let minNum = Math.min(leftNum, goodsNum); //单个商品中活动价能够购买数量
                  if (buyNum <= minNum) {
                    activeBuyNum = buyNum;
                  } else {
                    activeBuyNum = minNum;
                  }
                  item.activeBuyNum = activeBuyNum;
                }
              }
            }
          } else {
            let array = [];
            for (let v1 of activeGoods) {
              if (v.activityId == v1.activityId) {
                array.push(v1);
              }
            }
            // 活动商品数量大于订单限制,给活动商品的价格做排序，取最优值
            let sortActiveGoodsList = array.sort(_this.compare);
            sortActiveGoodsList.reverse();
            // 按排序好的活动商品按照各个限制，重新做区分，分成活动价和非活动价
            let leftOrderNum = v.orderNum; // 剩余活动订单限购数量
            for (var i = 0; i < sortActiveGoodsList.length; i++) {
              if (leftOrderNum > 0) {
                var activeBuyNum;
                var buyNum = sortActiveGoodsList[i].cartNum; //单个商品购买数量
                var leftNum = sortActiveGoodsList[i].leftNum; //活动商品剩余库存
                var goodsNum = sortActiveGoodsList[i].goodsNum; //活动商品限购数量
                var minNum = Math.min(leftNum, goodsNum, leftOrderNum); //单个商品中活动价能够购买数量
                if (buyNum <= minNum) {
                  activeBuyNum = buyNum
                } else {
                  activeBuyNum = minNum
                }
                leftOrderNum = leftOrderNum - activeBuyNum; // 去掉该商品活动数量后，剩余活动订单限购数量
                // 遍历购物车，给该id商品加属性activeBuyNum
                for (var m in market) {
                  for (let item of market[m]) {
                    // item.attr_id = item.attrIdArr.join("-")
                    if (item.attrIdArr) {
                      item.attr_id = item.attrIdArr.join("-")
                      if (sortActiveGoodsList[i].sku_id == item.sku_id && item.attr_id == sortActiveGoodsList[i].attr_id) {
                        item.activeBuyNum = activeBuyNum
                      }
                    } else {
                      if (sortActiveGoodsList[i].sku_id == item.sku_id) {
                        item.activeBuyNum = activeBuyNum
                      }
                    }

                  }
                }
              }
            }
          }

        }
      }

      // if (orderNumList.length > 0) { //有订单限购的情况下
      //   _this.orderNum = Math.min.apply(null, orderNumList); //取最小值订单限制
      //   if (_this.activeGoodsNum <= _this.orderNum) {
      //     //判断活动商品数量在订单限制以内
      //     for (var key in market) {
      //       for (let item of market[key]) {
      //         if (item.activityId > 0) { //是特价商品
      //           var activeBuyNum;
      //           var buyNum = item.cartNum; //单个商品购买数量
      //           var leftNum = item.leftNum; //活动商品剩余库存
      //           var goodsNum = item.goodsNum; //活动商品限购数量
      //           var minNum = Math.min(leftNum, goodsNum); //单个商品中活动价能够购买数量
      //           if (buyNum <= minNum) {
      //             activeBuyNum = buyNum
      //           } else {
      //             activeBuyNum = minNum
      //           }
      //           item.activeBuyNum = activeBuyNum
      //         }
      //       }
      //
      //     }
      //   } else {
      //     // 活动商品数量大于订单限制,给活动商品的价格做排序，取最优值
      //     let sortActiveGoodsList = activeGoods.sort(_this.compare)
      //     sortActiveGoodsList.reverse()
      //     //按排序好的活动商品按照各个限制，重新做区分，分成活动价和非活动价
      //     var leftOrderNum = _this.orderNum; // 剩余活动订单限购数量
      //     for (var i = 0; i < sortActiveGoodsList.length; i++) {
      //       if (leftOrderNum > 0) {
      //         var activeBuyNum;
      //         var buyNum = sortActiveGoodsList[i].cartNum; //单个商品购买数量
      //         var leftNum = sortActiveGoodsList[i].leftNum; //活动商品剩余库存
      //         var goodsNum = sortActiveGoodsList[i].goodsNum; //活动商品限购数量
      //         var minNum = Math.min(leftNum, goodsNum, leftOrderNum); //单个商品中活动价能够购买数量
      //         if (buyNum <= minNum) {
      //           activeBuyNum = buyNum
      //         } else {
      //           activeBuyNum = minNum
      //         }
      //         leftOrderNum = leftOrderNum - activeBuyNum; // 去掉该商品活动数量后，剩余活动订单限购数量
      //         // 遍历购物车，给该id商品加属性activeBuyNum
      //         for (var m in market) {
      //           for (let item of market[m]) {
      //             // item.attr_id = item.attrIdArr.join("-")
      //             if (item.attrIdArr) {
      //               item.attr_id = item.attrIdArr.join("-")
      //               if (sortActiveGoodsList[i].sku_id == item.sku_id && item.attr_id == sortActiveGoodsList[i].attr_id) {
      //                 item.activeBuyNum = activeBuyNum
      //               }
      //             } else {
      //               if (sortActiveGoodsList[i].sku_id == item.sku_id) {
      //                 item.activeBuyNum = activeBuyNum
      //               }
      //             }
      //
      //           }
      //         }
      //       }
      //     }
      //   }
      // }
      // 遍历新的购物车，计算价格
      let chooseCatesTemp = [];
      for (var g in market) {
        for (let item of market[g]) {
          var singleTotalPrice, singleOriginPrice, singlePackFee;//单个商品现总价和原总价
          if (item.activeBuyNum > 0) { //购物车中有活动商品
            _this.hasSpecial = true;
            singleTotalPrice = (item.activePrice * item.activeBuyNum + item.salePrice * (item.cartNum - item.activeBuyNum)).toFixed(2);
          } else { //无活动商品
            singleTotalPrice = (item.salePrice * item.cartNum).toFixed(2);
          }
          singleOriginPrice = (item.salePrice * item.cartNum).toFixed(2);//单个折扣商品的总原价
          item.singleTotalPrice = singleTotalPrice;
          item.singleOriginPrice = singleOriginPrice;
          totalPrice += parseFloat(singleTotalPrice) // 商品总价
          originPrice += parseFloat(singleOriginPrice) // 商品总原价

          if (item.packing_fee && item.packing_fee_rule) {
            let n = 0;
            for (let v of packFeeDetail) {
              if (v.gd_code == item.gd_code) {
                v.cartNum = v.cartNum + item.cartNum;
                n++;
              }
            }
            if (n == 0) {
              packFeeDetail.push({
                gd_code: item.gd_code,
                title: item.gdName,
                subTitle: '每' + item.packing_fee_rule + '份收' + item.packing_fee + '元',
                cartNum: item.cartNum,
                packing_fee_rule: item.packing_fee_rule,
                packing_fee: item.packing_fee
              });
            }

          }
          // 判断每个分类是否包含必点商品
          if (item.cateType == 1) {
            if (chooseCatesTemp.indexOf(item.tag_id1) == -1) {
              chooseCatesTemp.push(item.tag_id1);
            }
          }
        }

      }
      // 打包费说明
      if (packFeeDetail.length > 0) {
        for (let v of packFeeDetail) {
          let value;
          if (v.cartNum > v.packing_fee_rule) {
            value = Math.ceil(v.cartNum / v.packing_fee_rule) * parseFloat(v.packing_fee);
          } else {
            value = parseFloat(v.packing_fee);
          }
          totalPackFee += parseFloat(value); // 打包费总价
          v.value = '¥' + value.toFixed(2) + '元';
        }
        packFeeDetail.push({title: '小计', value: '¥' + totalPackFee.toFixed(2) + '元'});
        let packingFeeDetail = {
          title: "打包费说明",
          value: {
            description: _this.shopDetail.packing_fee_notice,
            packingFeeDetail: packFeeDetail
          }
        }
        localStorage.setItem('packingFeeDetail', JSON.stringify(packingFeeDetail));
      }

      if (totalPackFee > 0) {
        totalPrice = parseFloat(totalPrice) + parseFloat(totalPackFee);
        originPrice = parseFloat(originPrice) + parseFloat(totalPackFee);
      }
      if (_this.needChooseCatesIds.sort().toString() == chooseCatesTemp.sort().toString()) {
        _this.hasNeedChoose = true;
      } else {
        _this.hasNeedChoose = false;
      }

      let reductionAmount;
      reductionAmount = (parseFloat(originPrice) - parseFloat(totalPrice)).toFixed(2);//已减多少元
      if (parseInt(reductionAmount) == reductionAmount) {
        _this.reductionAmount = parseInt(reductionAmount);
      } else {
        _this.reductionAmount = reductionAmount;
      }

      // 满减活动
      let fullReductionAmount = {}, nextFullReduction = [];//满足(满减金额，减去金额),不满足(满减金额，差额)
      if (_this.shopDetail.promotion_reduce && _this.shopDetail.promotion_reduce.reduce_info.length > 0) {//该商铺有满减活动
        if (!_this.hasSpecial) { //购物车无特价商品
          for (let item of _this.shopDetail.promotion_reduce.reduce_info) {
            if (parseFloat(totalPrice) - parseFloat(item.meet_price) >= 0) {
              let obj = {
                meet_price: item.meet_price,
                cut_price: item.cut_price
              }
              fullReductionAmount = {...obj};
            } else {
              let obj = {
                meet_price: item.meet_price,
                cut_price: item.cut_price,
                gap: (parseFloat(item.meet_price) - parseFloat(totalPrice)).toFixed(2)
              }
              nextFullReduction.push(obj);
            }
          }
          if (fullReductionAmount.cut_price && fullReductionAmount.cut_price > 0) {
            _this.reductionAmount = fullReductionAmount.cut_price;//已减
            totalPrice = parseFloat(totalPrice) - parseFloat(fullReductionAmount.cut_price);//满减之后金额
          }

          if (nextFullReduction.length > 0) {
            _this.nextFullReductionAmount = nextFullReduction[0].cut_price;//下一满减金额
            if (parseInt(nextFullReduction[0].gap) == nextFullReduction[0].gap) {
              _this.nextFullReductionAmountGap = parseInt(nextFullReduction[0].gap);//距下一满减金额差额
            } else {
              _this.nextFullReductionAmountGap = nextFullReduction[0].gap;//距下一满减金额差额
            }

          }
        }
      }

      // 购物车展示数据格式处理
      let cartArr = []
      for (let m in cartInfo[_this.shopCode].market) {
        for (let obj of cartInfo[_this.shopCode].market[m]) {
          if (obj.cartNum > 0) {
            cartArr.push(obj)
            // console.log(obj)
          }
        }
      }
      _this.shopCartInfo = cartArr;

      cartInfo[_this.shopCode].amount = totalPrice.toFixed(2);//计算后的总金额
      cartInfo[_this.shopCode].originAmount = originPrice.toFixed(2);//计算后的原价总金额
      cartInfo[_this.shopCode].packFee = totalPackFee.toFixed(2);//计算后的打包费总金额
      _this.cartAmount = cartInfo[_this.shopCode].amount;
      _this.cartOriginAmount = cartInfo[_this.shopCode].originAmount;
      _this.spreadPrice = (parseFloat(_this.thresholdAmount) - parseFloat(totalPrice)).toFixed(2);//起送价和总价差值
      _this.$store.commit('changeCartInfo', cartInfo)//更新购物车总价信息
    },
    // 增加商品
    addGoods: function (e) {
      var _this = this;
      let num = null;
      _this.shopCartInfo.forEach(item => {
        if (e.gdName == item.gdName || e.goods_name == item.gdName) {
          num = num + item.cartNum
        }
      })
      // 更改商品列表展示,整理goods字段信息
      if (e.restriction_type && num >= e.restriction_num) { //每单限购商品
        this.$toast({
          message: '此商品仅限购买' + e.restriction_num + '件哦!',
          duration: 1500
        });
        return;
      }
      if (e.smallNumber && e.smallNumber > e.stock) { //每单限购商品
        this.$toast({
          message: '库存不足!',
          duration: 1500
        });
        return;
      }
      // 判断加料属性
      if (e.attribute_list) {
        let attribute_list = e.attribute_list;
        for (let attr of attribute_list) {
          for (let v of e.attributes) {
            if (attr.addPrice === 1 && attr.attributeTypeId == v.id) {
              let len = v.attributeList.length;
              // 非必选
              if (attr.mustSelect === 0) {
                if (attr.maxBuyLimit != -1) {
                  if (len > attr.maxBuyLimit) {
                    this.$toast({
                      message: `[${attr.attributeTypeName}]最多选${attr.maxBuyLimit}个`,
                      duration: 1500
                    });
                    return;
                  }
                }
              } else {
                if (attr.minBuyLimit > 1) {
                  if (attr.maxBuyLimit === -1) {
                    if (len < attr.minBuyLimit) {
                      this.$toast({
                        message: `[${attr.attributeTypeName}]最少选${attr.minBuyLimit}个`,
                        duration: 1500
                      });
                      return;
                    }
                  } else if (attr.maxBuyLimit == attr.minBuyLimit) {
                    if (len != attr.minBuyLimit) {
                      this.$toast({
                        message: `[${attr.attributeTypeName}]只能选${attr.minBuyLimit}个`,
                        duration: 1500
                      });
                      return;
                    }
                  } else if (attr.maxBuyLimit > attr.minBuyLimit) {
                    if (len < attr.minBuyLimit || len > attr.maxBuyLimit) {
                      this.$toast({
                        message: `[${attr.attributeTypeName}]必选${attr.minBuyLimit}~${attr.maxBuyLimit}个`,
                        duration: 1500
                      });
                      return;
                    }
                  }
                } else {
                  if (attr.maxBuyLimit === -1) {
                    if (len < 1) {
                      this.$toast({
                        message: `[${attr.attributeTypeName}]最少选1个`,
                        duration: 1500
                      });
                      return;
                    }
                  } else if (attr.maxBuyLimit === 1) {
                    if (len != 1) {
                      this.$toast({
                        message: `[${attr.attributeTypeName}]只能选1个`,
                        duration: 1500
                      });
                      return;
                    }
                  } else if (attr.maxBuyLimit > 1) {
                    if (len < 1) {
                      this.$toast({
                        message: `[${attr.attributeTypeName}]最少选1个`,
                        duration: 1500
                      });
                      return;
                    }
                    if (len > attr.maxBuyLimit) {
                      this.$toast({
                        message: `[${attr.attributeTypeName}]最多选${attr.maxBuyLimit}个`,
                        duration: 1500
                      });
                      return;
                    }
                  }
                }
              }
            }
          }
        }
      }

      if (e.is_single_spec == 1) { //单规格商品
        e.specifications = e.sku_list[0]
      } else { //多规格
        if (e.sku_list.length == 1) {
          e.specifications = e.sku_list[0]
          if (!e.attributes) {
            e.specAttrStr = e.specifications.specification
          }
        }
      }
      if (e.specifications) {
        e.sku_id = e.specifications.sku_id
        e.activity_id = e.specifications.activity_id
        // e.activity_price = e.specifications.activity_price
        e.praise_rate = e.specifications.praise_rate
        if (!e.sales_price) {
          e.sales_price = e.specifications.sales_price
        }
        // e.sales_price = e.specifications.sales_price
        e.sales_status = e.specifications.sales_status
        e.sales_volume = e.specifications.sales_volume
        e.stock = e.specifications.stock
        e.specifications = e.specifications
        e.specification = {
          id: e.specifications.specification_id,
          name: e.specifications.specification
        }
        if (e.activity_id > 0) {
          e.num_per_goods = e.specifications.num_per_goods
          e.num_per_order = e.specifications.num_per_order
          e.left_stock = e.specifications.left_stock
          e.activity_desc = e.specifications.activity_desc
        }
      }

      if (e.attributes) { //有属性
        var arr = []
        for (let item of e.attributes) {
          arr.push(item.id)
          for (let obj of item.attributeList) {
            arr.push(obj.id)
          }
        }
        e.attrIdArr = arr;
      }
      if (e.specification) {
        var goodsList = []
        if(_this.req_type){
          goodsList = _this.myGoodsList;
        }else{
          goodsList = _this.goodsList;
        }
        for (var key in goodsList) {
          var goodList = goodsList[key].goods_list;
          if (goodList.length > 0) {
            for (var m in goodList) {
              if (e.sku_id == goodList[m].sku_id && e.tag_id == goodList[m].tag_id) {
                goodList[m].cartNum += 1
                e.cartNum = goodList[m].cartNum
              }
            }
          }
        }
      }
      _this.goodsDetail = {...e};
      //更改购物车存储数据
      var cartInfo = _this.cartInfo

      //判断库存是否还有
      for (var key in cartInfo[_this.shopCode].market) {
        if (key == e.sku_id) {
          for (let obj of cartInfo[_this.shopCode].market[key]) {
            if (obj.stock > obj.cartNum) {
              obj.noStock = false; //有库存

            } else {
              obj.noStock = true; //无库存
              _this.$toast('该商品库存为' + obj.stock + '件，下单可能会出现异常，请重新选择')
            }
          }

        }
      }
      // 判断cartInfo中是否有这个商品
      if (cartInfo[_this.shopCode].market.hasOwnProperty(e.sku_id)) { // 已有该商品sku_id
        if (e.attrIdArr) { //有属性
          let attrList = []
          for (let item of cartInfo[_this.shopCode].market[e.sku_id]) {
            attrList.push(JSON.stringify(item.attrIdArr))
          }
          if (attrList.indexOf(JSON.stringify(e.attrIdArr)) >= 0) { //有相同属性的商品
            for (let item of cartInfo[_this.shopCode].market[e.sku_id]) {
              if (item.attrIdArr.toString() == e.attrIdArr.toString()) {
                item.cartNum += 1
              }
            }
          } else { //无相同属性的商品
            // console.log('in')
            // console.log(e)
            var goodsId = e.sku_id;
            var goodsInfo = {
              gdName: e.goods_name,
              gd_code: e.gd_code,
              sku_id: e.sku_id,
              is_single_spec: e.is_single_spec,
              sku_list: e.sku_list,
              salePrice: e.sales_price,
              activePrice: e.activity_price,
              activityId: e.activity_id,
              cartNum: e.smallNumber ? e.smallNumber : 1,
              specification: e.specification, //规格
              original_tag_id: e.original_tag_id,
              specifications: e.specifications,
              stock: e.stock,
              restriction_type: e.restriction_type,
              restriction_num: e.restriction_num,
              tag_id1: e.original_tag_id,
              cateType: e.cateType,
              smallNumber: e.smallNumber,
              packing_fee: e.packing_fee,
              packing_fee_rule: e.packing_fee_rule
            };
            if (e.activity_id > 0) {
              goodsInfo.goodsNum = e.num_per_goods
              goodsInfo.orderNum = e.num_per_order
              goodsInfo.leftNum = e.left_stock
            }
            if (e.attributes) {
              goodsInfo.attributes = e.attributes; //属性
              goodsInfo.attrIdArr = e.attrIdArr; //属性id数组
            }
            goodsInfo.specAttrStr = e.specAttrStr; //规格属性拼接字符串
            cartInfo[_this.shopCode].market[goodsId].push(goodsInfo)
          }
        } else { //无属性
          for (let key in cartInfo[_this.shopCode].market) {
            for (let item of cartInfo[_this.shopCode].market[key]) {
              if (item.sku_id == e.sku_id) {
                item.cartNum += 1
              }
            }
          }
        }
      } else {
        var goodsId = e.sku_id;
        var goodsInfo = [{
          gdName: e.goods_name,
          gd_code: e.gd_code,
          sku_id: e.sku_id,
          is_single_spec: e.is_single_spec,
          sku_list: e.sku_list,
          salePrice: e.sales_price,
          activePrice: e.activity_price,
          activityId: e.activity_id,
          cartNum: e.smallNumber ? e.smallNumber : 1,
          specification: e.specification,//规格
          original_tag_id: e.original_tag_id,
          specifications: e.specifications,
          stock: e.stock,
          restriction_type: e.restriction_type,
          restriction_num: e.restriction_num,
          tag_id1: e.original_tag_id,
          cateType: e.cateType,
          smallNumber: e.smallNumber,
          packing_fee: e.packing_fee,
          packing_fee_rule: e.packing_fee_rule
        }];
        if (e.activity_id > 0) {
          goodsInfo[0].goodsNum = e.num_per_goods
          goodsInfo[0].orderNum = e.num_per_order
          goodsInfo[0].leftNum = e.left_stock
        }
        if (e.attributes) {
          goodsInfo[0].attributes = e.attributes//属性
          goodsInfo[0].attrIdArr = e.attrIdArr//属性id数组
        }
        goodsInfo[0].specAttrStr = e.specAttrStr//规格属性拼接字符串
        cartInfo[_this.shopCode].market[goodsId] = goodsInfo
      }

      cartInfo[_this.shopCode].total = parseInt(cartInfo[_this.shopCode].total) + 1;

      _this.cartTotal = cartInfo[_this.shopCode].total;

      //更新超市下的购物车信息
      if (_this.cartInfo[_this.shopCode].total) {
        _this.isFromSupperPage =  true
        _this.isClickSupperTag =  true
        let data = Object.values(cartInfo[_this.shopCode].market)
        let brr = new Map()
        for(let i = 0; i < data.length; i++){
          for(let item of data[i]){
            if(brr.has(item.tag_id1)){
              let num  = brr.get(item.tag_id1) + item.cartNum
              brr.set(item.tag_id1,num)
            }else{
              brr.set(item.tag_id1,item.cartNum)
            }
          }
        }
        _this.cartInfoTags = brr
      }
      //更新购物车商品信息
      _this.$store.commit('changeCartInfo', cartInfo);
      //计算购物车商品总价
      _this.getTotalPrice();
      if(_this.shopDetail.req_type){
        _this.getGoodsList1();
      }else{
        _this.getGoodsList()
      }
      _this.propSpecInfo = false;//多规格弹框

      //判断该商品是否为特价 折扣商品
      if (e.activity_id > 0) {
        //判断购物车中活动商品数量是否超过订单限购数量
        let activityNums = 0;
        for (let v of _this.activeGoodsArray) {
          if (v.activityId == e.activity_id) {
            activityNums = v.activityNums;
          }
        }
        if (activityNums == e.num_per_order + 1) {
          _this.$toast('每单最多享受' + e.num_per_order + '份特价折扣，超出部分为您恢复原价')
          return;
        }
        for (var key in cartInfo[_this.shopCode].market) {
          let list = cartInfo[_this.shopCode].market[key];
          for (let v of list) {
            if (v.sku_id == e.sku_id) {
              //判断购物车中该商品数量是否超出特价剩余数量
              if (v.cartNum == v.leftNum + 1) {
                _this.$toast('特价折扣商品剩余0份，已原价购买')
                return;
              }
              //判断购物车中该商品数量是否超出特价限购数量
              if (v.cartNum == v.goodsNum + 1) {
                _this.$toast('特价折扣商品限购' + e.num_per_goods + '份，超出部分为您恢复原价')
                return;
              }
            }
          }

        }
      }
    },
    // 删减商品
    minusGoods: function (e) {
      var _this = this
      if (e.is_single_spec == 1) {//单规格
        e.sku_id = e.sku_list[0].sku_id
      }else{
        if(e.activity_id > 0 && e.sku_list && e.sku_list.length == 1){
          e.sku_id = e.sku_list[0].sku_id;
        }
      }
      var goodsList = []
      if(_this.req_type){
        goodsList = _this.myGoodsList;
      }else{
        goodsList = _this.goodsList;
      }

      for (var key in goodsList) {
        var goodList = goodsList[key].goods_list
        if (goodList.length > 0) {
          for (let item of goodList) {
            for (let obj of item.sku_list) {
              if (obj.sku_id == e.sku_id) {
                if (obj.smallNumber) {
                  if ((item.cartNum - 1) < obj.smallNumber) {
                    item.cartNum = 0
                  } else {
                    item.cartNum -= 1
                  }
                } else {
                  if (item.cartNum > 0) {
                    item.cartNum -= 1
                  } else {
                    item.cartNum = 0
                  }
                }

              }
            }
          }
        }
      }
      // 更新购物车数据
      var cartInfo = _this.cartInfo
      for (let m in cartInfo[_this.shopCode].market[e.sku_id]) {
        if (e.attrIdArr) {
          if (e.attrIdArr.toString() == cartInfo[_this.shopCode].market[e.sku_id][m].attrIdArr.toString()) {
            cartInfo[_this.shopCode].market[e.sku_id][m].cartNum -= 1
            if (e.smallNumber && cartInfo[_this.shopCode].market[e.sku_id][m].cartNum < e.smallNumber) {
              cartInfo[_this.shopCode].market[e.sku_id][m].cartNum = 0
            }
          }
        } else {
          cartInfo[_this.shopCode].market[e.sku_id][m].cartNum -= 1
          if (e.smallNumber && cartInfo[_this.shopCode].market[e.sku_id][m].cartNum < e.smallNumber) {
            cartInfo[_this.shopCode].market[e.sku_id][m].cartNum = 0
          }
        }
        if (cartInfo[_this.shopCode].market[e.sku_id][m].cartNum == 0) {
          cartInfo[_this.shopCode].market[e.sku_id].splice(m, 1)
        }
        if (cartInfo[_this.shopCode].market[e.sku_id].length == 0) {
          delete cartInfo[_this.shopCode].market[e.sku_id]
        }
      }
      if (cartInfo[_this.shopCode].total > 0) {
        cartInfo[_this.shopCode].total -= 1
      }
      if (cartInfo[_this.shopCode].total == 0) {
        _this.propShow = false
      }

      _this.cartTotal = cartInfo[_this.shopCode].total
      //更新超市下的购物车信息
      if (_this.cartInfo[_this.shopCode].total) {
        _this.isFromSupperPage =  true
        _this.isClickSupperTag =  true
        let data = Object.values(_this.cartInfo[_this.shopCode].market)
        let arr = new Map()
        for(let i = 0; i < data.length; i++){
          for(let item of data[i]){
            if(arr.has(item.tag_id1)){
              let num  = arr.get(item.tag_id1) + item.cartNum
              arr.set(item.tag_id1,num)
            }else{
              arr.set(item.tag_id1,item.cartNum)
            }
          }
        }
        _this.cartInfoTags = arr
      }
      _this.$store.commit('changeCartInfo', cartInfo)
      _this.getTotalPrice()
      if(_this.shopDetail.req_type){
        _this.getGoodsList1();
      }else{
        _this.getGoodsList()
      }

    },
    clearCart: function () {
      var _this = this
      var cartInfo = _this.cartInfo
      cartInfo[_this.shopCode] = {
        total: 0,
        amount: 0,
        market: {}
      }
      _this.$store.commit('changeCartInfo', cartInfo)
      if(_this.shopDetail.req_type){
        _this.getGoodsList1();
      }else{
        _this.getGoodsList()
      }
      _this.cartTotal = 0
      _this.propShow = !_this.propShow
      _this.reductionAmount = '';//已减金额
      _this.nextFullReductionAmount = '';//下一满减金额
      _this.nextFullReductionAmountGap = '';//距下一满减金额差额
      _this.shopCartInfo = [];
    },
    toggleProp: function (e, item) {//item为_this.goodsDetail
      var _this = this
      _this.attributes = []
      if (e == 'cart') {
        _this.propShow = !_this.propShow
      } else if (e == 'shopInfo') {
        _this.propShopInfo = !_this.propShopInfo
      } else if (e == 'goodInfo') {
        _this.propGoodInfo = !_this.propGoodInfo
        _this.goodsDetail = item
      } else if (e == 'specInfo') {
        _this.propSpecInfo = !_this.propSpecInfo
        if (_this.propSpecInfo) {
          _this.propGoodInfo = false
        }
        if (item) {
          _this.goodsDetail = item;
          let first_spec = _this.goodsDetail.sku_list.find((obj) => {//找出第一个符合条件的规格
            if (obj.is_can_choose == 1) {
              return obj
            }
          })
          if (_this.goodsDetail.sku_list) {
            for (let obj of _this.goodsDetail.sku_list) {
              if (obj.sku_id == first_spec.sku_id) {
                obj.is_selected = 1;
                _this.goodsDetail.specifications = obj;
              } else {
                obj.is_selected = 0;
              }
            }
          }
          if (_this.goodsDetail.attribute_list) {  //有属性 每个属性的第一个值作为默认选项
            for (let obj of item.attribute_list) {
              if (obj.addPrice === 0) {
                for (let n in obj.attributeList) {
                  if (n == 0) {
                    let attributeParams = {
                      id: obj.attributeTypeId,
                      name: obj.attributeTypeName,
                      attributeList: [{
                        id: obj.attributeList[n].id,
                        name: obj.attributeList[n].name
                      }]
                    }
                    _this.attributes.push(attributeParams)//属性
                    obj.attributeList[n].is_selected = 1//选中
                  } else {
                    obj.attributeList[n].is_selected = 0
                  }
                }
              } else {
                // 是否必须提示
                let selectTips = '';
                if (obj.mustSelect === 1) {
                  // 必选
                  if (obj.minBuyLimit > 1) {
                    if (obj.maxBuyLimit === -1) {
                      // 不限
                      selectTips = `必选，最少选${obj.minBuyLimit}`;
                    }
                    if (obj.maxBuyLimit == obj.minBuyLimit) {
                      selectTips = `必选${obj.minBuyLimit}个`;
                    }
                    if (obj.maxBuyLimit > obj.minBuyLimit) {
                      selectTips = `可选${obj.minBuyLimit}~${obj.maxBuyLimit}个`;
                    }
                  } else {
                    // 不限或1
                    if (obj.maxBuyLimit === -1) {
                      // 最多选不限
                      selectTips = '必选，最少选1个';
                    }
                    if (obj.maxBuyLimit === 1) {
                      // 最多选不限
                      selectTips = '必选1个';
                    }
                    if (obj.maxBuyLimit > 1) {
                      // 最多选不限
                      selectTips = `必选，最多选${obj.maxBuyLimit}个`;
                    }
                  }
                } else {
                  if (obj.minBuyLimit === -1) {
                    if (obj.maxBuyLimit === -1) {
                      selectTips = '非必选';
                    } else {
                      selectTips = `非必选，最多选${obj.maxBuyLimit}个`;
                    }
                  }
                }
                obj.selectTips = selectTips;
                for (let n in obj.attributeList) {
                  obj.attributeList[n].is_selected = 0;
                }
                let attributeParams = {
                  id: obj.attributeTypeId,
                  name: obj.attributeTypeName,
                  attributeList: []
                }
                _this.attributes.push(attributeParams)//属性
              }
            }
            _this.goodsDetail.attributes = _this.attributes
          }

          if (_this.goodsDetail.specifications.specification && _this.goodsDetail.attributes) {
            let AttrStr = [];
            for (let item2 of _this.goodsDetail.attributes) {
              for (let item3 of item2.attributeList) {
                AttrStr.push(item3.name)
              }
            }
            _this.goodsDetail.specAttrStr = _this.goodsDetail.specifications.specification + '/' + AttrStr.join('/')
          } else if (!_this.goodsDetail.specifications.specification && _this.goodsDetail.attributes) {
            let AttrStr = [];
            for (let item2 of _this.goodsDetail.attributes) {
              for (let item3 of item2.attributeList) {
                AttrStr.push(item3.name)
              }
            }
            _this.goodsDetail.specAttrStr = AttrStr.join('/')
          } else if (_this.goodsDetail.specifications.specification && !_this.goodsDetail.attributes) {
            _this.goodsDetail.specAttrStr = _this.goodsDetail.specifications.specification
          }
          _this.goodsDetail.activity_price = _this.goodsDetail.specifications.activity_price;
          _this.goodsDetail.sales_price = _this.goodsDetail.specifications.sales_price;
        }
      }
    },
    // 切换规格属性操作
    handleSelect(type, item, parent) {
      var _this = this
      _this.$forceUpdate();
      if (type == 'spec') { //选择规格
        if (item.is_can_choose == 1) {
          for (let obj of _this.goodsDetail.sku_list) {
            if (obj.sku_id == item.sku_id) {
              _this.$set(obj, 'is_selected', 1)//选中值
              _this.$set(_this.goodsDetail, 'specifications', obj)//规格
              _this.getGoodPrice();
            } else {
              _this.$set(obj, 'is_selected', 0)
            }
          }
        }
      } else if (type == 'attr') { //选择属性
        for (var obj of _this.goodsDetail.attribute_list) {
          if (obj.attributeTypeId == parent.attributeTypeId) {
            for (var obj2 of obj.attributeList) {
              if (parent.addPrice === 0) {
                if (obj2.id == item.id) {
                  _this.$set(obj2, 'is_selected', 1)//选中值
                  for (var obj3 of _this.goodsDetail.attributes) {
                    if (obj3.id == parent.attributeTypeId) {
                      obj3.attributeList[0] = {
                        id: obj2.id,
                        name: obj2.name
                      }
                    }
                  }
                } else {
                  _this.$set(obj2, 'is_selected', 0)
                }
              } else {
                // 加料属性
                if (item.saleStatus == 1) {
                  if(item.is_selected === 0 && _this.goodsDetail.attributes && _this.goodsDetail.attributes.length > 0){
                    let arr = _this.goodsDetail.attributes.filter(attrItem => attrItem.id == parent.attributeTypeId);
                    if(arr && arr.length > 0 && arr[0].attributeList.length == parent.maxBuyLimit){
                      this.$toast({
                        message: `[${parent.attributeTypeName}]最多选${parent.maxBuyLimit}个`,
                        duration: 1500
                      });
                      return;
                    }
                  }
                  if (obj2.id == item.id) {
                    let is_selected = 1 - obj2.is_selected;
                    _this.$set(obj2, 'is_selected', is_selected);
                    for (var obj3 of _this.goodsDetail.attributes) {
                      if (obj3.id == parent.attributeTypeId) {
                        if (is_selected == 1) {
                          obj3.attributeList.push({
                            id: obj2.id,
                            name: obj2.name,
                            salePrice: obj2.salePrice,
                            costPrice: obj2.costPrice,
                            skuCode: obj2.skuCode
                          })
                        } else {
                          let index = 0;
                          for (let i = 0; i < obj3.attributeList.length; i++) {
                            if (obj3.attributeList[i] == obj2.id) {
                              index = i;
                            }
                          }
                          obj3.attributeList.splice(index, 1);
                        }
                      }
                    }
                    _this.getGoodPrice()
                  }
                }
              }
            }
          }
        }
      }

      if (_this.goodsDetail.attribute_list && _this.goodsDetail.attribute_list.length > 0) {
        _this.attributes = _this.goodsDetail.attributes
        let AttrStr = [];
        for (let item2 of _this.attributes) {
          for (let item3 of item2.attributeList) {
            AttrStr.push(item3.name)
          }
        }
        if (_this.goodsDetail.specifications.specification) {
          _this.goodsDetail.specAttrStr = _this.goodsDetail.specifications.specification + '/' + AttrStr.join('/')
        } else {
          _this.goodsDetail.specAttrStr = AttrStr.join('/')
        }
      } else {
        if (_this.goodsDetail.specifications.specification) {
          _this.goodsDetail.specAttrStr = _this.goodsDetail.specifications.specification
        }
      }
    },
    // 计算多规格商品价格
    getGoodPrice() {
      let salePrice = this.goodsDetail.specifications.sales_price;
      let activityPrice = this.goodsDetail.specifications.activity_price;
      if (this.goodsDetail.attributes) {
        for (let v1 of this.goodsDetail.attributes) {
          for (let v2 of v1.attributeList) {
            if (v2.salePrice) {
              salePrice = (parseFloat(salePrice) + parseFloat(v2.salePrice)).toFixed(2)
              activityPrice = (parseFloat(activityPrice) + parseFloat(v2.salePrice)).toFixed(2)
            }
          }
        }
      }
      this.goodsDetail.sales_price = salePrice;
      this.goodsDetail.activity_price = activityPrice;
    },

    compare: function (obj1, obj2) {
      return obj1.priceGap - obj2.priceGap
    },
    // 获取用户默认地址
    postDefaultAddress: function (resolve) {
      var _this = this;
      actions.postDefaultAddress(_this, {school_id: this.$store.state.schoolInfo.schoolId}, function (data) { // 未设置默认地址的时候，返回的是最新地址
        if (data && data.mp) {
          let mp_real = _this.$utils.Decrypt(data.mp_encryption)

          if (!window.localStorage.getItem('selfTakeMp') || window.localStorage.getItem('selfTakeMp') == 'undefined' || window.localStorage.getItem('selfTakeMp') == 'null') {
            // window.localStorage.setItem('selfTakeMp', data.mp)
            window.localStorage.setItem('selfTakeMp', mp_real)
          } else {
            let selfTakeMp = window.localStorage.getItem('selfTakeMp');
            if (selfTakeMp.indexOf('*') >= 0) {
              window.localStorage.setItem('selfTakeMp', mp_real)
            }
          }
          if (_this.shopDetail.is_self_take_new == 1) {//仅自提店铺
            resolve(window.localStorage.getItem('selfTakeMp'))
          } else {
            resolve(mp_real)
          }
          window.localStorage.setItem('chooseAddress', JSON.stringify(data))
        } else {
          window.localStorage.removeItem("chooseAddress")
          if (!window.localStorage.getItem('selfTakeMp') || window.localStorage.getItem('selfTakeMp') == 'undefined' || window.localStorage.getItem('selfTakeMp') == 'null') {
            window.localStorage.setItem('selfTakeMp', _this.$store.state.userInfo.mp)
          } else {
            let selfTakeMp = window.localStorage.getItem('selfTakeMp');
            if (selfTakeMp.indexOf('*') >= 0) {
              window.localStorage.setItem('selfTakeMp', _this.$store.state.userInfo.mp)
            }
          }
          if (_this.shopDetail.is_self_take_new == 1) {//仅自提店铺
            resolve(window.localStorage.getItem('selfTakeMp'))
          } else {
            resolve(_this.$store.state.userInfo.mp)
          }
        }
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '');
      })
    },

    //结算
    settleAccounts() {
      new Promise(this.postDefaultAddress).then((res) => {
        this.orderPreview(res)
      })
    },


    // 订单预检
    orderPreview: function (mp) {
      var _this = this
      window.localStorage.removeItem('selectedCoupon')
      window.localStorage.removeItem('date')
      window.localStorage.removeItem('dateList')
      window.localStorage.removeItem('couponList')
      window.localStorage.removeItem('orderPreviewInfo')
      window.localStorage.removeItem('order-type')
      window.localStorage.removeItem('canSubmit')
      window.localStorage.removeItem('shop_comment');
      window.localStorage.removeItem('isSelectedCoupon');
      window.localStorage.removeItem('order-type');
      var goods = []
      var uid = _this.$store.state.wxUid
      if (uid == "null" || uid == '' || uid == null) {//如果没有登录信息先跳转登录页
        // _this.$router.push({name: 'Login'})
        _this.$utils.toLogin(_this);
      } else {
        var market = _this.cartInfo[_this.shopCode].market;
        var chooseCatesIds = [];
        for (var key in market) {
          for (let item of market[key]) {
            var good1 = {}, good2 = {}; //good1活动商品 good2原价商品
            if (item.cateType == 1) {
              if (chooseCatesIds.indexOf(item.tag_id1) == -1) {
                chooseCatesIds.push(item.tag_id1);
              }
            }
            if (item.activeBuyNum > 0) {
              //判断是活动商品
              good1.price = item.activePrice + '';
              good1.original_price = item.salePrice + '';
              good1.number = item.activeBuyNum;
              good1.goods_sale_id = item.sku_id + '';
              if ((item.cartNum - item.activeBuyNum) > 0) {
                good2.price = item.salePrice + '';
                good2.number = item.cartNum - item.activeBuyNum;
                good2.goods_sale_id = item.sku_id + '';
                good2.specification = {//规格
                  id: 0,
                  name: ''
                }
                if (item.specification.name) {
                  good2.specification.name = item.specification.name
                }
                if (item.specification.id) {
                  good2.specification.id = item.specification.id
                }
                if (item.attributes) {//属性
                  good2.attributes = item.attributes;
                }
              }
              good1.specification = {//规格
                id: 0,
                name: ''
              }
              if (item.specification.name) {
                good1.specification.name = item.specification.name
              }
              if (item.specification.id) {
                good1.specification.id = item.specification.id
              }
              if (item.attributes) {//属性
                good1.attributes = item.attributes;
              }

            } else {
              good2.price = item.salePrice + '';
              good2.number = item.cartNum;
              good2.goods_sale_id = item.sku_id + '';
              good2.specification = {//规格
                id: 0,
                name: ''
              }
              if (item.specification.name) {
                good2.specification.name = item.specification.name
              }
              if (item.specification.id) {
                good2.specification.id = item.specification.id
              }
              if (item.attributes) {//属性
                good2.attributes = item.attributes;
              }
            }
            if (JSON.stringify(good2) != '{}') {
              goods.push(good2)
            }
            if (JSON.stringify(good1) != '{}') {
              goods.push(good1)
            }
          }
        }
        // 加价属性
        for (let v of goods) {
          let attributePrice = 0;
          if (v.attributes && v.attributes.length > 0) {
            for (let v1 of v.attributes) {
              for (let v2 of v1.attributeList) {
                if (v2.salePrice || v2.salePrice === 0) {
                  attributePrice = (parseFloat(attributePrice) + parseFloat(v2.salePrice)).toFixed(2);
                }
              }
            }
          }
          v.attributePrice = attributePrice;
        }
        if (_this.needChooseCates.length > 0) {
          if (chooseCatesIds.length === 0) {
            _this.$messagebox.alert(`需添加[${_this.needChooseCates[0].tag_name}]中的商品才可下单~`, '')
            if(_this.req_type){
              _this.scrollGoods1(_this.needChooseCates[0]);
            }else{
              _this.scrollGoods(_this.needChooseCates[0]);
            }
            return
          } else {
            for (let v of _this.needChooseCates) {
              if (chooseCatesIds.indexOf(v.tag_id.toString()) === -1) {
                _this.$messagebox.alert(`需添加[${v.tag_name}]中的商品才可下单~`, '')
                if(_this.req_type){
                  _this.scrollGoods1(v);
                }else{
                  _this.scrollGoods(v);
                }
                return
              }
            }
          }
        }
        var params = {
          school_id: _this.schoolInfo.schoolId,
          supplier_id: _this.shopCode,
          supplier_short_name: _this.shopDetail.shop_name,
          goods: goods,
          // client_type: 7,
          orderType: _this.orderType, //1支持自提，0不支持自提,(外送和外送+自提:0,仅自提:1)
          mobile: mp,
        };
        // 如果有默认地址，传默认地址经纬度
        let chooseAddress = window.localStorage.getItem('chooseAddress')
        if(chooseAddress){
          if (JSON.parse(chooseAddress).isLimitFloor) {
            params.buildingId = JSON.parse(chooseAddress).build_id;
            params.building = JSON.parse(chooseAddress).build_name;
            params.floorId = JSON.parse(chooseAddress).floor_id;
            params.floor = JSON.parse(chooseAddress).floor_name;
            params.roomId = JSON.parse(chooseAddress).room_id;
            params.room = JSON.parse(chooseAddress).room_name;
            params.isSelectAddress = 1;
          } else {
            params.isSelectAddress = 1
            params.address_lng = JSON.parse(chooseAddress).lon
            params.address_lat = JSON.parse(chooseAddress).lat
          }
        }
        actions.postOrderPreview(_this, params, function (data) {
          if (data.flag === 1001) {
            _this.$messagebox.alert('商家不存在', '')
            _this.$router.push({name: 'TagPage'})
          } else if (data.flag === 1002) {
            _this.$messagebox.alert('商品价格信息错误', '')
            return
          } else if (data.flag === 1003) {
            _this.$messagebox.alert('库存不足', '')
            return
          } else if (data.flag === 1004) {
            _this.$messagebox.alert('商品已售完', '')
            return
          } else if (data.flag === 1005) {
            _this.$messagebox.alert('超过限购数量', '')
            return
          } else if (data.flag === 1007) {
            _this.$messagebox.alert('不满足商家起送价', '')
            return
          } else if (data.flag === 1008) {
            _this.$messagebox.alert('商家已打烊', '')
            return
          } else {
            // 商品有更新
            if (data.update_goods && data.update_goods.length > 0) {
              // _this.$messagebox.alert(data.update_goods[0].good_name + data.update_goods[0].message, '')
              _this.changeGoodsInCart = [];
              let update_goods = _.uniqWith(data.update_goods, _.isEqual)
              for (let v of update_goods) {
                if (v.goods_sale_id) {
                  for (let v1 of _this.shopCartInfo) {
                    if (v1.sku_id == v.goods_sale_id) {
                      _this.changeGoodsInCart.push({
                        sku_id: v1.sku_id,
                        name: v1.gdName + (v1.specAttrStr ? ('-' + v1.specAttrStr) : ''),
                        num: v.number,
                        message: v.messageBackUp
                      })
                    }
                  }

                }
              }
              if (_this.changeGoodsInCart.length > 0) {
                _this.isShowCartGoods = true;
              }
              return;
            }
          }
          var dateList = data.deliveryDateTimeList;
          for (var i = 0; i < dateList.length; i++) {
            if (i === 0) {
              dateList[i].isActive = true
            } else {
              dateList[i].isActive = false
            }
          }
          data.deliveryDateTimeList = dateList;
          window.localStorage.setItem('orderPreviewInfo', JSON.stringify(data));
          window.localStorage.setItem('shop_code', _this.shopCode);
          window.localStorage.setItem('shop_name', _this.shopDetail.shop_name);
          window.localStorage.setItem('orderPreviewType', 1)
          window.localStorage.removeItem('hikes')
          _this.$router.push({name: 'OrderSettle'})

        })
      }
    },
    showOtherInfo: function (data) {
      var _this = this;
      if (data.image_list.length > 0 || data.content != '') {
        window.localStorage.setItem('otherDetail', JSON.stringify(data));
        _this.$router.push({'path': '/otherdetail'})
      } else {
        MessageBox.alert('店铺尚未上传内容', '')
      }
    },
    scrollGoods2: function (item,index) {
      let title = document.getElementById(item.tag_id) ? document.getElementById(item.tag_id).clientHeight : 0
      let val = document.getElementById(item.tag_id+'goods'+index).offsetHeight
      var y = document.getElementById(item.tag_id).offsetTop + title + val * index;
      if(this.req_type){
        myScroll1.scrollTo(0, -y, 200);
      }else{
        myScroll.scrollTo(0, -y, 200);
      }
    },
    scrollGoods1: function (item) {
      var tag = 0
      this.myGoodsList.forEach((el,index) => {
          el.goods_list = []
          if(el.tag_id == item.tag_id){
            this.myIndex = index
            tag = el.is_special_tag
          }
      })
      this.page = 0
      var navBox = document.getElementById("scrollBox1");
      var navBoxChild = navBox.children;
      navBox.scrollTop = navBoxChild[0].clientHeight * (this.myIndex-1) - navBox.offsetTop
      for (var j = 0; j < navBoxChild.length; j++) {
        navBoxChild[j].className = "";
      }
      navBoxChild[this.myIndex].className = "active";
      myScroll1.scrollTo(0, 0, 200);
      this.getShopTagList(0,item.tag_id,tag)
    },
    scrollGoods: function (item) {
      var y = document.getElementById(item.tag_id).offsetTop;
      myScroll.scrollTo(0, -y, 200);
    },
    readyWxshare: function () {
      var _this = this;
      var u = encodeURIComponent(window.location.href.split('#')[0]);
      actions.getJsShareConf(this, u, function (data) {
        wx.config({
          debug: false,
          appId: data.data.appId,
          timestamp: data.data.timestamp,
          nonceStr: data.data.nonceStr,
          signature: data.data.signature,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
        });
        wx.ready(function () {
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          var link;
          if (_this.$utils.isWxWork()) {
            link = _this.$utils.getHost() + '/wxWork';
          } else {
            link = _this.$utils.getAgentApiHost() + '/wechat/auth/enter?redirect=goodslist&data=' + encodeURIComponent(JSON.stringify({'shopCode': _this.shopCode}))
          }
          _this.$utils.wxShareNew(
            _this.shopDetail.shop_name, // 分享标题
            link, // 分享链接
            _this.shopDetail.pic, // 分享图标
            '俺来也微信校内订餐平台' // 分享描述
          );
        });
        wx.error(function (res) {
          console.log(res)
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        })
      });
    },

    goToGood(){
      let data = this.goodsList
      for(let k = 0 ;k < data.length;k++){
        for(let v = 0; v < data[k].goods_list.length; v++){
          if(data[k].goods_list[v].gd_code == this.gdCode){
            var y = document.getElementById(data[k].tag_name);
            y.scrollIntoView({behavior: "instant",block:"start"})
            this.scrollGoods2(data[k],v)
          }
        }
      }
    },

    // 店铺优惠券
    getGrantlist(n) {
      let _this = this;
      const params = {
        shop_id: this.shopCode,
        school_id: this.schoolInfo.schoolId,
        shop_cate_id: this.shopDetail.shop_cate_id
      };
      actions.shopGrantList(_this, params, function (data) {
        if (data && data.coupon_list && data.coupon_list.length > 0) {
          for (let v of data.coupon_list) {
            let amount = v.couponAmount;
            let index = String(amount).indexOf(".") + 1;//获取小数点的位置
            if (index > 0) {
              let temp = String(amount).split('.');
              v.decimal = temp[1];
              v.couponAmount = temp[0];
            }
            if (v.couponName && v.couponName.length > 5) {
              v.couponName = v.couponName.substring(0, 5) + '...';
            }
          }
          _this.couponInfo = data;
          if (n) {
            _this.couponModalOpened = data.is_toast == 1 ? true : false;
            if (data.is_toast == 1) {
              // console.log(_this.$store.state.wxUid)
              if (_this.$store.state.wxUid) {
                _this.setCouponToast();
              }
            }
          }
        }
        // _this.$toast('领取成功')
      }, function (response) {
        _this.$messagebox.alert(response.message)
        // 响应错误回调
      })
    },
    // 领取店铺优惠券
    receiveCoupon(item) {
      let _this = this;
      if (item.status == 1 || item.status == 2) {
        return;
      }
      let param = {
        coupon_code: item.couponCode,
        shop_id: this.shopCode,
        school_id: this.schoolInfo.schoolId
      };
      actions.receiveShopGrant(_this, param, function (data) {
        _this.$toast('领取成功');
        _this.getGrantlist();
      }, function (response) {
        _this.$messagebox.alert(response.body.message)
        // 响应错误回调
      })
    },
    // 购买券包
    buyCouponPackage(item) {
      this.$router.push({name: 'CouponPackage', query: {id: item.promotion_id}})
      // 埋点
      var clickParams = [{
        uid: this.$store.state.wxUid,
        code: 'click_shop_coupon_bag',
        createTime: new Date().getTime(),
        refId: item.promotion_id,
        firstValue: this.schoolInfo.schoolId,
        secondValue: this.shopCode
      }]
      this.addLog1(clickParams);
    },
    // 一键领取
    receiveAllCoupons(e) {
      e.stopPropagation();
      let _this = this;
      let temp = [];
      for (let v of this.couponInfo.coupon_list) {
        temp.push(v.couponCode);
      }
      let param = {
        coupon_code_list: temp.join(','),
        shop_id: this.shopCode,
        school_id: this.schoolInfo.schoolId
      };
      let params = {
        params: param
      }
      actions.receiveAllShopGrant(_this, param, function (data) {
        _this.$toast('一键领取成功');
        _this.couponModalOpened = false;
        _this.getGrantlist();
        // _this.setCouponToast();
      })
    },
    // 设置优惠券弹框
    setCouponToast() {
      let _this = this;
      let param = {
        shop_id: this.shopCode
      };
      let params = {
        params: param
      }
      actions.setGrantTotast(_this, param, function (data) {

      })
    },
    closeCouponModal() {
      this.couponModalOpened = false;
    },
    viewPackDesc() {
      this.$router.push({name: 'PackingFee'});
    },
    // 店铺内搜索
    toShopSearch() {
      this.showShopSearch = true;
      this.keyword = '';
      // this.$refs.keyword.focus();
      this.$nextTick(() => {
        document.getElementById('keyword').focus();
      })
    },
    closeShopSearch() {
      this.showShopSearch = false;
      this.searchResults = [];
    },
    submitShopSearch() {
      if (this.keyword.length === 0) {
        // this.$messagebox.alert('请输入搜索关键字', '')
        return;
      }
      let params = {
        keyword: this.keyword,
        schoolId: this.schoolInfo.schoolId,
        shopCode: this.shopCode,
        display: 1,
        saleStatus: 2
      }
      this.searchResults = [];
      let url = this.$utils.getSpliceHost('search-center') + '/search/priv/goods/in/shop/search';
      let _this = this;
      _this.$http.post(url, params).then((response) => {
        let res = response.body;
        if (res.data && res.data.goodsResponses && res.data.goodsResponses.length > 0) {
          let goodsResponses = res.data.goodsResponses,shopGoods = [],
            searchResults = [];
          if(_this.req_type){
            shopGoods = _this.myGoodsList
          }else{
            shopGoods = _this.goodsList
          }
          for (let v1 of shopGoods) {
            if (v1.is_special_tag === 0) {
              for (let v2 of v1.goods_list) {
                for (let v of goodsResponses) {
                  if (v.gdCode === v2.gd_code) {
                    searchResults.push(v2);
                  }
                }
              }
            }
          }
          if (searchResults.length > 0) {
            _this.searchResults = searchResults;
            _this.iShowSearchNothing = false;
          } else {
            _this.iShowSearchNothing = true;
          }
        } else {
          _this.iShowSearchNothing = true;
        }
      })
    },
    // 统计埋点
    addLog1(list) {
      var _this = this;
      var params = {
        logDetails: list,
        source: 3
      }
      actions.postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {

      })
    }
  },
  isIos: function () {
    var u = navigator.userAgent;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == 'ShopList' || to.name == 'OrderList' || to.name == 'TagPage') {
      to.meta.isUseCache = true;
    }
    if (this.isIos && !this.$utils.resolveUrl().isShare && document.domain.indexOf('xiyoushi.com') < 0) {
      window.history.replaceState({}, '', this.shopUrl);
    }
    // var u  = encodeURIComponent(window.location.href.split('#')[0]);
    // var _this = this;
    // actions.getJsShareConf(_this,u,function (data) {
    //   let host = _this.$utils.getHost();
    //   wx.config({
    //     debug: false,
    //     appId: data.data.appId,
    //     timestamp: data.data.timestamp,
    //     nonceStr: data.data.nonceStr,
    //     signature: data.data.signature,
    //     jsApiList: data.data.jsApiList
    //   });
    //   wx.ready(function () {
    //     _this.$utils.wx_share(
    //       '【俺来也】校内订餐，暖心服务', // 分享标题
    //       host + '/auth', // 分享链接
    //       host + '/share.png', // 分享图标
    //       '订餐首选俺来也，美味餐食极速送达，爱吃节最低2.7元' // 分享描述
    //     );
    //   });
    //   wx.error(function (res) {
    //     // console.log(res)
    //     // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    //   })
    // });

    next()
  },
  components: {
    PreviewPicture,
    CommentStars
  }
}
</script>
<style scoped>
.fs-40{
  font-size: .4rem;
}
.navbar {
  display: flex;
  align-items: center;
}

.navbar.col33 a {
  width: 21%;
}

/* 店铺内搜索 */
.shop-search {
  display: flex;
  align-items: center;
}

.shop-search .box {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  width: 2rem;
  height: .54rem;
  margin-left: .3rem;
  border-radius: .35rem;
  padding: 0 .25rem;
  background-color: #F4F4F4;
  color: #9b9b9b;
}

.shop-search img {
  width: .24rem;
  margin-right: .15rem;
  height: auto;
}

.shop-search-body {
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 8;
}

.shop-search-body .shop-header {
  position: relative;
  display: flex;
  height: 1rem;
  line-height: 1rem;
  /* padding-left: 75rpx; */
  font-size: .36rem;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  /*text-align: center;*/
}

.shop-search-body .shop-header .back {
  position: absolute;
  left: .25rem;
  width: 1rem;
  height: 100%;
  display: flex;
  align-items: center;
}

.shop-search-body .search-input {
  display: flex;
  align-items: center;
  width: 85%;
  /*margin: .25rem;*/
  margin-bottom: 0;
  padding: .15rem .25rem;
  border-radius: .35rem;
  background-color: #F4F4F4;
  color: #9b9b9b;
}

.shop-search-body .search-input input {
  width: 80%;
  font-size: .26rem;
  color: #666;
  background-color: #F4F4F4;
  padding-left: .1rem;
}

.shop-search-body .search-list {
  margin: 0 .25rem .25rem .25rem;
  height: 85vh;
  overflow-y: scroll;
}

.shop-search-body .search-list::-webkit-scrollbar {
  display: none;
}

.shop-search-body .nothing {
  padding: 2rem 0;
  text-align: center;
  color: #666;
}

.goodimg {
  border: none;
}

/*店铺优惠券*/
.shop-coupon {
  /* display: flex; */
  width: 100%;
  height: .72rem;
  padding: 0 .26rem;
  margin-bottom: .2rem;
  overflow: hidden;
  white-space: nowrap;
  overflow-x: scroll;
  display: -webkit-box;
}

.shop-coupon::-webkit-scrollbar {
  display: none;
}

.shop-coupon .coupon-item {
  position: relative;
  display: inline-block;
  /* width: 2.63rem; */
  height: 100%;
  /* height: 70rpx; */
  background-color: #EC6145;
  border-radius: .08rem;
  margin-right: .12rem;
}
.shop-coupon .coupon-item.package{
  background-color: #FF4A61;
}

.shop-coupon .coupon-item.checked {
  background-color: #FFEDF0;
  border: 1px solid #FF92A0;
}
.shop-coupon .coupon-item.package.checked {
  background-color: #FFBCC5;
  color: #fff;
}

.shop-coupon .coupon-item .info {
  /*position: absolute;*/
  /*width: 100%;*/
  height: 100%;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  padding-left: .18rem;
}
.shop-coupon .coupon-item .info .c-line{
  height: 100%;
  width: auto;
}

.shop-coupon .coupon-item .info div,
.shop-coupon .coupon-item .info span {
  color: #fff;
}

.shop-coupon .coupon-item.checked .info div,
.shop-coupon .coupon-item.checked .info span {
  color: #FF4A61;
}

/* 优惠券弹框 */
.dialog-coupon {
  position: relative;
  width: 100%;
  /*top: 12%;*/
  /*left: 0;*/
}

.dialog-coupon .coupon-box {
  position: absolute;
  top: 2.74rem;
  bottom: .1rem;
  /*height: 3.48rem;*/
  left: .76rem;
  right: .76rem;
  overflow-y: scroll;
}

.dialog-coupon .coupon-box::-webkit-scrollbar {
  display: none;
}

.dialog-coupon .coupon-box .card {
  position: relative;
  /*margin: .2rem .2rem 0;*/
  /*height: 1.3rem;*/
  margin-bottom: .2rem;
  background-image: url("../assets/images/coupon-bg1.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
}

.dialog-coupon .coupon-box .card .cnt {
  padding: .3rem 0 .3rem .3rem;
}

.dialog-coupon .coupon-box .card .cnt .fc-red {
  color: #E8503D;
}

.dialog-coupon .btn-receive {
  position: absolute;
  bottom: .34rem;
  left: 2.2rem;
  right: 2.2rem;
  /* width: 300rpx; */
  height: .82rem;
  font-size: .32rem;
  line-height: .82rem;
  text-align: center;
  font-weight: bold;
  color: #fff;
}

.dialog-coupon .coupon-box .card .cnt .get {
  width: 1.5rem;
  height: .5rem;
  line-height: .5rem;
  background-color: #ed4634;
  opacity: 0.8;
  border-radius: .24rem;
  color: #fff;
  font-size: .26rem;
  text-align: center;
  /*margin-left: .15rem;*/
}

.dialog-coupon .coupon-box .card .cnt .get.checked {
  opacity: 0.4;
}

.mm .thumbnail {
  width: 50%;
  height: 2rem;
}

.sys_busy {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999;
  text-align: center;
  background: #fff;
}

.my-content {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.my-content img {
  width: 2.00rem;
  height: 2.74rem;
  margin: 0 auto;
}

.my-content div {
  font-weight: 400;
  color: #666666;
  line-height: .34rem;
  font-size: .24rem;
  margin-top: .24rem;
}

.no-more{
  font-size: .14rem;
  color: #9c9c9c;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// GoodsList.vue?6a4c228b